import { A as e, B as t, C as n, D as r, E as i, F as a, G as o, H as s, I as c, L as l, M as u, N as d, O as f, P as p, R as m, S as h, T as g, U as _, V as v, W as y, _ as b, a as x, b as S, c as C, d as ee, f as te, g as ne, h as w, i as re, j as T, k as ie, l as ae, m as oe, n as se, o as ce, p as le, r as E, s as ue, u as de, v as fe, w as pe, x as me, y as he, z as ge } from "./flushSceneShapes-c7ttw7D-.js";
import { r as _e, t as ve } from "./Area-MLM4Xe0E.js";
import { t as ye } from "./MapReader-BeVNpm6y.js";
import D from "konva";
//#region \0rolldown/runtime.js
var be = Object.create, xe = Object.defineProperty, Se = Object.getOwnPropertyDescriptor, Ce = Object.getOwnPropertyNames, we = Object.getPrototypeOf, Te = Object.prototype.hasOwnProperty, O = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Ee = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ce(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Te.call(e, s) && s !== n && xe(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Se(t, s)) || r.enumerable
	});
	return e;
}, De = (e, t, n) => (n = e == null ? {} : be(we(e)), Ee(t || !e || !e.__esModule ? xe(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Oe = .6, ke = .025, Ae = "rgb(225, 225, 225)";
function je() {
	return {
		roomSize: Oe,
		lineWidth: ke,
		lineColor: Ae,
		backgroundColor: "#000000",
		instantMapMove: !1,
		highlightCurrentRoom: !0,
		cullingEnabled: !0,
		cullingMode: "indexed",
		coalesceRooms: !1,
		cullingBounds: null,
		labelRenderMode: "image",
		transparentLabels: !1,
		roomShape: "rectangle",
		hiddenRooms: "hide",
		playerMarker: {
			strokeColor: "#00e5b2",
			strokeAlpha: 1,
			fillColor: "#00e5b2",
			fillAlpha: 0,
			strokeWidth: .1,
			sizeFactor: 1.7,
			dash: [.05, .05],
			dashEnabled: !0,
			matchRoomShape: !1
		},
		highlight: {
			strokeAlpha: 1,
			fillAlpha: 0,
			strokeWidth: .1,
			sizeFactor: 1.425,
			dash: [.05, .05],
			dashEnabled: !0,
			matchRoomShape: !0,
			shape: "match"
		},
		gridEnabled: !1,
		gridSize: 1,
		gridColor: "rgba(200, 200, 200, 0.15)",
		gridLineWidth: .03,
		borders: !0,
		frameMode: !1,
		coloredMode: !1,
		emboss: !1,
		areaName: !0,
		fontFamily: "sans-serif",
		uniformLevelSize: !1,
		areaExitLabels: !1,
		areaExitLabelFontSize: .3,
		neighborSpill: !1,
		neighborSpillDistance: 20,
		lodEnabled: !1,
		lodRoomBudget: 16e3,
		lodHitTestBudget: 1e4,
		lodExitBudget: 12e3
	};
}
//#endregion
//#region src/MapState.ts
var Me = class {
	constructor(e, t) {
		this.events = new p(), this.highlights = /* @__PURE__ */ new Map(), this.paths = [], this.lens = u, this.mapReader = e, this.settings = t;
	}
	setLens(e) {
		this.lens = e, this.events.emit("lens", { lens: e });
	}
	setArea(e, t) {
		let n = this.mapReader.getArea(e);
		return n ? (this.currentArea = e, this.currentAreaInstance = n, this.currentZIndex = t, this.currentAreaVersion = n.getVersion(), this.events.emit("area", {
			area: n,
			zIndex: t
		}), !0) : !1;
	}
	setPosition(e, t = !0) {
		let n = this.mapReader.getRoom(e);
		if (!n) return !1;
		let r = this.mapReader.getArea(n.area), i = r?.getVersion(), a = this.currentArea !== n.area || this.currentZIndex !== n.z || i !== void 0 && this.currentAreaVersion !== i || r !== void 0 && this.currentAreaInstance !== r;
		return a && this.setArea(n.area, n.z), this.positionRoomId = e, this.events.emit("position", {
			roomId: e,
			center: t,
			areaChanged: a
		}), !0;
	}
	updatePositionMarker(e) {
		this.positionRoomId = e, this.events.emit("position", {
			roomId: e,
			center: !1,
			areaChanged: !1
		});
	}
	refreshPosition() {
		this.positionRoomId !== void 0 && this.events.emit("position", {
			roomId: this.positionRoomId,
			center: !1,
			areaChanged: !1
		});
	}
	clearPosition() {
		this.positionRoomId = void 0, this.events.emit("position", {
			roomId: void 0,
			center: !1,
			areaChanged: !1
		});
	}
	setCenterRoom(e, t) {
		let n = this.mapReader.getRoom(e);
		if (!n) return !1;
		let r = this.currentArea !== n.area || this.currentZIndex !== n.z;
		return (r || this.needsAreaRedraw(n)) && this.setArea(n.area, n.z), this.centerRoomId = e, this.events.emit("center", {
			roomId: e,
			instant: t ?? r
		}), !0;
	}
	needsAreaRedraw(e) {
		let t = this.mapReader.getArea(e.area), n = t?.getVersion();
		return n !== void 0 && this.currentAreaVersion !== n || t !== void 0 && this.currentAreaInstance !== t;
	}
	addHighlight(e, t) {
		let n = this.mapReader.getRoom(e);
		if (!n) return !1;
		let r = Array.isArray(t) ? t.length > 0 ? [...t] : ["#ffffff"] : [t];
		return this.highlights.set(e, {
			colors: r,
			color: r[0],
			area: n.area,
			z: n.z
		}), this.events.emit("highlight", {
			roomId: e,
			colors: r,
			color: r[0]
		}), !0;
	}
	removeHighlight(e) {
		this.highlights.has(e) && (this.highlights.delete(e), this.events.emit("highlight", {
			roomId: e,
			colors: void 0,
			color: void 0
		}));
	}
	hasHighlight(e) {
		return this.highlights.has(e);
	}
	clearHighlights() {
		this.highlights.clear(), this.events.emit("clear", void 0);
	}
	addPath(e, t = "#66E64D") {
		this.paths.push({
			locations: e,
			color: t
		}), this.events.emit("path", void 0);
	}
	clearPaths() {
		this.paths = [], this.events.emit("path", void 0);
	}
	getOverlaysForArea(e) {
		let t = { ...e };
		if (this.positionRoomId !== void 0) {
			let e = this.mapReader.getRoom(this.positionRoomId);
			e && e.area === this.currentArea && e.z === this.currentZIndex && (t.position = { roomId: this.positionRoomId });
		}
		let n = [...e?.highlights ?? []];
		for (let [e, t] of this.highlights) t.area === this.currentArea && t.z === this.currentZIndex && n.push({
			roomId: e,
			color: t.colors
		});
		n.length > 0 && (t.highlights = n);
		let r = [...e?.paths ?? []];
		return r.push(...this.paths), r.length > 0 && (t.paths = r), t;
	}
	getEffectiveBounds(e, t) {
		return this.settings.uniformLevelSize ? e.getFullBounds() : t.getBounds();
	}
	computeExportBounds(e, t, n, r) {
		if (n !== void 0) {
			let e = this.mapReader.getRoom(n);
			if (!e) throw Error(`Room ${n} not found`);
			return {
				x: e.x - r,
				y: e.y - r,
				w: r * 2,
				h: r * 2
			};
		}
		let i = this.getEffectiveBounds(e, t), a = this.settings.areaName ? e.getAreaName() : void 0, o = a ? 7 : 0, s = a ? 3.5 : 0, c = i.minX - s, l = i.minY - o, u = a ? i.minX - 3.5 + a.length * 2.5 * .6 : -Infinity, d = Math.max(i.maxX, u);
		return {
			x: c - r,
			y: l - r,
			w: d - c + r * 2,
			h: i.maxY - l + r * 2
		};
	}
};
//#endregion
//#region src/scene/elements/GridLayout.ts
function Ne(e, t, n = {}) {
	if (!t.gridEnabled) return [];
	let r = n.inverseTransform ?? ((e, t) => ({
		x: e,
		y: t
	})), { minX: i, maxX: a, minY: o, maxY: s } = e, c = r(i, o), l = r(a, o), u = r(a, s), d = r(i, s), f = Math.min(c.x, l.x, u.x, d.x), p = Math.max(c.x, l.x, u.x, d.x), m = Math.min(c.y, l.y, u.y, d.y), h = Math.max(c.y, l.y, u.y, d.y), g = t.gridSize * 2, _ = Math.floor((f - g) / t.gridSize) * t.gridSize, v = Math.ceil((p + g) / t.gridSize) * t.gridSize, y = Math.floor((m - g) / t.gridSize) * t.gridSize, b = Math.ceil((h + g) / t.gridSize) * t.gridSize, x = [], S = {
		stroke: t.gridColor,
		strokeWidth: t.gridLineWidth
	};
	for (let e = _; e <= v; e += t.gridSize) x.push({
		type: "line",
		points: [
			e,
			y,
			e,
			b
		],
		paint: S,
		grid: !0,
		layer: "grid"
	});
	for (let e = y; e <= b; e += t.gridSize) x.push({
		type: "line",
		points: [
			_,
			e,
			v,
			e
		],
		paint: S,
		grid: !0,
		layer: "grid"
	});
	return x;
}
//#endregion
//#region src/export/clipSceneToViewport.ts
function Pe(e, t, n, r) {
	if (!n.cullingEnabled) return /* @__PURE__ */ new Map();
	let { minX: i, maxX: a, minY: o, maxY: s } = t, c = n.roomSize / 2, l = r?.forward, u = (e, t, n, r) => {
		if (l) {
			let c = Fe(e, t, n, r, l);
			return c.maxX >= i && c.minX <= a && c.maxY >= o && c.minY <= s;
		}
		return n >= i && e <= a && r >= o && t <= s;
	}, d = /* @__PURE__ */ new Map();
	for (let { room: t, shape: n } of e.roomShapeRefs.values()) d.set(n, u(t.x - c, t.y - c, t.x + c, t.y + c));
	for (let { shape: t, bounds: n } of e.standaloneExitShapeRefs) d.set(t, u(n.x, n.y, n.x + n.width, n.y + n.height));
	for (let { shape: t, bounds: n } of e.labelShapeRefs) d.set(t, u(n.x, n.y, n.x + n.width, n.y + n.height));
	for (let { shape: t, bounds: n } of e.specialExitShapeRefs) d.set(t, u(n.x, n.y, n.x + n.width, n.y + n.height));
	for (let { shape: t, bounds: n } of e.stubShapeRefs) d.set(t, u(n.x, n.y, n.x + n.width, n.y + n.height));
	for (let { shape: t, bounds: n } of e.areaExitLabelShapeRefs) d.set(t, u(n.x, n.y, n.x + n.width, n.y + n.height));
	return d;
}
function Fe(e, t, n, r, i) {
	let a = i(e, t), o = i(n, t), s = i(n, r), c = i(e, r);
	return {
		minX: Math.min(a.x, o.x, s.x, c.x),
		minY: Math.min(a.y, o.y, s.y, c.y),
		maxX: Math.max(a.x, o.x, s.x, c.x),
		maxY: Math.max(a.y, o.y, s.y, c.y)
	};
}
function Ie(e, t, n, r) {
	let i = Ne(t, n, { inverseTransform: r?.inverse });
	if (!n.cullingEnabled) return {
		...e.sceneShapes,
		grid: i
	};
	let a = Pe(e, t, n, r);
	return {
		grid: i,
		link: e.sceneShapes.link.filter((e) => a.get(e) ?? !0),
		room: e.sceneShapes.room.filter((e) => a.get(e) ?? !0),
		topLabel: e.sceneShapes.topLabel
	};
}
//#endregion
//#region src/render/CullIndex.ts
var Le = 256, Re = 2, ze = 32, Be = 1 << 20, Ve = class {
	constructor() {
		this.entries = [], this.allShapes = /* @__PURE__ */ new Set(), this.linear = !0, this.originX = 0, this.originY = 0, this.cellSize = 1, this.cols = 0, this.rows = 0, this.cells = [], this.oversized = [], this.stamp = new Int32Array(), this.queryGen = 0;
	}
	build(e) {
		this.entries = e, this.allShapes = new Set(e.map((e) => e.shape));
		let t = e.length;
		if (t < Le) {
			this.linear = !0;
			return;
		}
		this.linear = !1;
		let n = Infinity, r = Infinity, i = -Infinity, a = -Infinity;
		for (let t of e) t.minX < n && (n = t.minX), t.minY < r && (r = t.minY), t.maxX > i && (i = t.maxX), t.maxY > a && (a = t.maxY);
		let o = Math.max(i - n, 1e-6), s = Math.max(a - r, 1e-6), c = Math.sqrt(o * s / Math.max(t / Re, 1));
		(!isFinite(c) || c <= 0) && (c = Math.max(o, s));
		let l = Math.max(1, Math.ceil(o / c)), u = Math.max(1, Math.ceil(s / c));
		for (; l * u > Be;) c *= 2, l = Math.max(1, Math.ceil(o / c)), u = Math.max(1, Math.ceil(s / c));
		this.originX = n, this.originY = r, this.cellSize = c, this.cols = l, this.rows = u, this.cells = Array.from({ length: l * u }, () => []), this.oversized = [], this.stamp = new Int32Array(t), this.queryGen = 0;
		for (let i = 0; i < t; i++) {
			let t = e[i], a = this.clampCol(Math.floor((t.minX - n) / c)), o = this.clampCol(Math.floor((t.maxX - n) / c)), s = this.clampRow(Math.floor((t.minY - r) / c)), u = this.clampRow(Math.floor((t.maxY - r) / c));
			if ((o - a + 1) * (u - s + 1) > ze) {
				this.oversized.push(i);
				continue;
			}
			for (let e = s; e <= u; e++) {
				let t = e * l;
				for (let e = a; e <= o; e++) this.cells[t + e].push(i);
			}
		}
	}
	getAllShapes() {
		return this.allShapes;
	}
	queryVisible(e) {
		let t = /* @__PURE__ */ new Set(), { minX: n, maxX: r, minY: i, maxY: a } = e;
		if (this.linear) {
			for (let e of this.entries) e.maxX >= n && e.minX <= r && e.maxY >= i && e.minY <= a && t.add(e.shape);
			return t;
		}
		let o = ++this.queryGen, s = this.stamp, c = this.entries, l = this.cols, u = this.clampCol(Math.floor((n - this.originX) / this.cellSize)), d = this.clampCol(Math.floor((r - this.originX) / this.cellSize)), f = this.clampRow(Math.floor((i - this.originY) / this.cellSize)), p = this.clampRow(Math.floor((a - this.originY) / this.cellSize));
		for (let e = f; e <= p; e++) {
			let f = e * l;
			for (let e = u; e <= d; e++) {
				let l = this.cells[f + e];
				for (let e = 0; e < l.length; e++) {
					let u = l[e];
					if (s[u] === o) continue;
					s[u] = o;
					let d = c[u];
					d.maxX >= n && d.minX <= r && d.maxY >= i && d.minY <= a && t.add(d.shape);
				}
			}
		}
		for (let e = 0; e < this.oversized.length; e++) {
			let o = c[this.oversized[e]];
			o.maxX >= n && o.minX <= r && o.maxY >= i && o.minY <= a && t.add(o.shape);
		}
		return t;
	}
	clampCol(e) {
		return e < 0 ? 0 : e >= this.cols ? this.cols - 1 : e;
	}
	clampRow(e) {
		return e < 0 ? 0 : e >= this.rows ? this.rows - 1 : e;
	}
};
function He(t, n, r, i, a) {
	if (a === e) return {
		minX: t,
		minY: n,
		maxX: r,
		maxY: i
	};
	let o = a(t, n), s = a(r, n), c = a(r, i), l = a(t, i);
	return {
		minX: Math.min(o.x, s.x, c.x, l.x),
		minY: Math.min(o.y, s.y, c.y, l.y),
		maxX: Math.max(o.x, s.x, c.x, l.x),
		maxY: Math.max(o.y, s.y, c.y, l.y)
	};
}
//#endregion
//#region src/rendering/SceneManager.ts
var Ue = {
	grid: [],
	link: [],
	room: [],
	topLabel: []
}, We = class {
	constructor(e, t, n) {
		this.camera = e, this.settings = t, this.standaloneExitShapeSet = /* @__PURE__ */ new Set(), this.pipeline = new w(n, t);
	}
	get exitRenderer() {
		return this.pipeline.exitRenderer;
	}
	get lastResult() {
		return this.lastBuildResult;
	}
	get drawnExits() {
		return this.lastBuildResult?.drawnExits ?? [];
	}
	get drawnSpecialExits() {
		return this.lastBuildResult?.drawnSpecialExits ?? [];
	}
	get drawnStubs() {
		return this.lastBuildResult?.drawnStubs ?? [];
	}
	get areaExitHitZones() {
		return this.lastBuildResult?.areaExitHitZones ?? [];
	}
	get hitShapes() {
		return this.lastBuildResult?.hitShapes ?? [];
	}
	rebuild(e, t, n, r, i) {
		return this.lastBuildResult = this.pipeline.buildScene(e, t, n, r, i), this.standaloneExitShapeSet = new Set(this.lastBuildResult.standaloneExitShapeRefs.map((e) => e.shape)), this.cullIndex = void 0, this.cullIndexTransform = void 0, this.lastBuildResult;
	}
	buildExitShape(e) {
		return this.pipeline.buildExitShape(e);
	}
	reset() {
		this.lastBuildResult = void 0, this.standaloneExitShapeSet = /* @__PURE__ */ new Set(), this.cullIndex = void 0, this.cullIndexTransform = void 0;
	}
	resetPipeline(e) {
		this.pipeline = new w(e, this.settings), this.reset();
	}
	cullInteractive(t = e) {
		if (!this.lastBuildResult) return /* @__PURE__ */ new Set();
		let n = this.ensureCullIndex(t);
		if (!this.settings.cullingEnabled) return new Set(n.getAllShapes());
		let r = this.camera.getCullingViewport(this.settings.cullingBounds);
		return n.queryVisible(r);
	}
	managedShapes(t = e) {
		return this.lastBuildResult ? new Set(this.ensureCullIndex(t).getAllShapes()) : /* @__PURE__ */ new Set();
	}
	ensureCullIndex(e) {
		if (this.cullIndex && this.cullIndexTransform === e) return this.cullIndex;
		let t = new Ve();
		return t.build(this.buildCullEntries(e)), this.cullIndex = t, this.cullIndexTransform = e, t;
	}
	buildCullEntries(e) {
		let t = this.lastBuildResult, n = this.settings.roomSize / 2, r = [], i = (t, n, i, a, o) => {
			let s = He(n, i, a, o, e);
			r.push({
				shape: t,
				minX: s.minX,
				minY: s.minY,
				maxX: s.maxX,
				maxY: s.maxY
			});
		};
		for (let { room: e, shape: r } of t.roomShapeRefs.values()) i(r, e.x - n, e.y - n, e.x + n, e.y + n);
		for (let { shape: e, bounds: n } of t.standaloneExitShapeRefs) i(e, n.x, n.y, n.x + n.width, n.y + n.height);
		for (let { shape: e, bounds: n } of t.labelShapeRefs) i(e, n.x, n.y, n.x + n.width, n.y + n.height);
		for (let { shape: e, bounds: n } of t.specialExitShapeRefs) i(e, n.x, n.y, n.x + n.width, n.y + n.height);
		for (let { shape: e, bounds: n } of t.stubShapeRefs) i(e, n.x, n.y, n.x + n.width, n.y + n.height);
		for (let { shape: e, bounds: n } of t.areaExitLabelShapeRefs) i(e, n.x, n.y, n.x + n.width, n.y + n.height);
		return r;
	}
	cull(t = e) {
		if (!this.lastBuildResult) return {
			shapes: Ue,
			stats: {
				visibleRooms: 0,
				totalRooms: 0,
				visibleExits: 0
			}
		};
		let n = this.camera.getCullingViewport(this.settings.cullingBounds), r = t === e ? void 0 : { forward: t }, i = Ie(this.lastBuildResult, n, this.settings, r);
		return {
			shapes: i,
			stats: {
				visibleRooms: i.room.length,
				totalRooms: this.lastBuildResult.roomShapeRefs.size,
				visibleExits: i.link.filter((e) => this.standaloneExitShapeSet.has(e)).length
			}
		};
	}
};
//#endregion
//#region src/render/canvasGradient.ts
function k(e, t) {
	if (typeof t == "string") return t;
	if (t.type === "linear") {
		let n = e.createLinearGradient(t.x0, t.y0, t.x1, t.y1);
		for (let e of t.stops) n.addColorStop(e.offset, e.color);
		return n;
	}
	let n = t.fx ?? t.cx, r = t.fy ?? t.cy, i = t.fr ?? 0, a = e.createRadialGradient(n, r, i, t.cx, t.cy, t.r);
	for (let e of t.stops) a.addColorStop(e.offset, e.color);
	return a;
}
//#endregion
//#region src/render/RecordingLayer.ts
function A(e, t) {
	switch (t.type) {
		case "rect":
			e.beginPath(), t.cr > 0 && typeof e.roundRect == "function" ? e.roundRect(t.x, t.y, t.w, t.h, t.cr) : e.rect(t.x, t.y, t.w, t.h), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, t.dash ? e.setLineDash(t.dash) : e.setLineDash([]), e.stroke());
			break;
		case "circle":
			e.beginPath(), e.arc(t.cx, t.cy, t.r, 0, Math.PI * 2), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, t.dash ? e.setLineDash(t.dash) : e.setLineDash([]), e.stroke());
			break;
		case "line": {
			if (t.points.length < 4) break;
			let n = e.globalAlpha;
			t.alpha !== void 0 && (e.globalAlpha = t.alpha), e.beginPath(), e.moveTo(t.points[0], t.points[1]);
			for (let n = 2; n < t.points.length; n += 2) e.lineTo(t.points[n], t.points[n + 1]);
			t.stroke && (e.strokeStyle = t.stroke), e.lineWidth = t.sw, t.dash ? e.setLineDash(t.dash) : e.setLineDash([]), t.lineCap && (e.lineCap = t.lineCap), t.lineJoin && (e.lineJoin = t.lineJoin), e.stroke(), t.alpha !== void 0 && (e.globalAlpha = n);
			break;
		}
		case "polygon":
			if (t.vertices.length < 4) break;
			e.beginPath(), e.moveTo(t.vertices[0], t.vertices[1]);
			for (let n = 2; n < t.vertices.length; n += 2) e.lineTo(t.vertices[n], t.vertices[n + 1]);
			e.closePath(), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, e.setLineDash([]), e.stroke());
			break;
		case "text": {
			let n = t.fontSize * 100, r = `${t.fontStyle} ${n}px ${t.fontFamily}`;
			e.save(), e.font = r, e.fillStyle = t.fill, t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw * 100, e.lineJoin = "round");
			let i = t.baselineRatio !== void 0;
			if (t.transform) if (e.transform(...t.transform), e.scale(1 / 100, 1 / 100), e.textAlign = "center", i) {
				e.textBaseline = "alphabetic";
				let n = (t.h / 2 + t.baselineRatio * t.fontSize) * 100;
				t.stroke && t.sw > 0 && e.strokeText(t.text, t.w * 100 / 2, n), e.fillText(t.text, t.w * 100 / 2, n);
			} else {
				e.textBaseline = "middle";
				let n = t.w * 100 / 2, r = t.h * 100 / 2;
				t.stroke && t.sw > 0 && e.strokeText(t.text, n, r), e.fillText(t.text, n, r);
			}
			else if (t.w > 0 && t.h > 0) {
				e.textAlign = t.align || "left";
				let n = t.align === "center" ? t.x + t.w / 2 : t.x;
				if (e.scale(1 / 100, 1 / 100), t.vAlign === "middle" && i) {
					e.textBaseline = "alphabetic";
					let r = t.y + t.h / 2 + t.baselineRatio * t.fontSize;
					t.stroke && t.sw > 0 && e.strokeText(t.text, n * 100, r * 100), e.fillText(t.text, n * 100, r * 100);
				} else {
					e.textBaseline = t.vAlign === "middle" ? "middle" : "top";
					let r = t.vAlign === "middle" ? t.y + t.h / 2 : t.y;
					t.stroke && t.sw > 0 && e.strokeText(t.text, n * 100, r * 100), e.fillText(t.text, n * 100, r * 100);
				}
			} else e.textAlign = "left", e.textBaseline = "top", e.scale(1 / 100, 1 / 100), t.stroke && t.sw > 0 && e.strokeText(t.text, t.x * 100, t.y * 100), e.fillText(t.text, t.x * 100, t.y * 100);
			e.restore();
			break;
		}
		case "image":
			if (!t.image) break;
			t.transform ? (e.save(), e.transform(...t.transform), e.drawImage(t.image, 0, 0, t.w, t.h), e.restore()) : e.drawImage(t.image, t.x, t.y, t.w, t.h);
			break;
	}
}
var Ge = class {
	constructor(e, t) {
		this._visible = !0, this.noScaling = !1, this.commands = [], this.x = e, this.y = t;
	}
	setVisible(e) {
		this._visible = e, this._konvaGroup?.visible(e);
	}
	isVisible() {
		return this._visible;
	}
	destroy() {
		this._konvaGroup?.destroy(), this._konvaGroup = void 0, this.commands.length = 0;
	}
	setPosition(e, t) {
		this.x = e, this.y = t, this._konvaGroup?.position({
			x: e,
			y: t
		});
	}
	getPosition() {
		return {
			x: this.x,
			y: this.y
		};
	}
	moveToTop() {
		this._konvaGroup?.moveToTop();
	}
	materialize() {
		if (this._konvaGroup) return this._konvaGroup;
		let e = new D.Group({
			x: this.x,
			y: this.y,
			listening: !1,
			visible: this._visible
		}), t = this.commands;
		return e.add(new D.Shape({
			listening: !1,
			perfectDrawEnabled: !1,
			sceneFunc: (e) => {
				let n = e._context;
				for (let e of t) A(n, e);
			}
		})), this._konvaGroup = e, e;
	}
};
function Ke(e) {
	if (e.noScaling || e.commands.length !== 1) return null;
	let t = e.commands[0];
	return t.type === "rect" ? typeof t.fill != "string" && t.fill !== void 0 || t.dash ? null : `r|${t.fill ?? ""}|${t.stroke ?? ""}|${t.sw}|${t.cr}` : t.type === "circle" ? typeof t.fill != "string" && t.fill !== void 0 || t.dash ? null : `c|${t.fill ?? ""}|${t.stroke ?? ""}|${t.sw}|${t.r}` : t.type === "line" ? t.dash || t.alpha !== void 0 ? null : `l|${t.stroke ?? ""}|${t.sw}|${t.lineCap ?? ""}|${t.lineJoin ?? ""}` : null;
}
var qe = class {
	constructor(e, t = () => !1) {
		this.coalesce = t, this.entries = [], this.nodeToEntry = /* @__PURE__ */ new Map(), this.buckets = /* @__PURE__ */ new Map(), this.konvaLayer = e, e.destroyChildren();
		let n = this;
		this.konvaShape = new D.Shape({
			listening: !1,
			perfectDrawEnabled: !1,
			sceneFunc: (e) => {
				let t = e._context;
				n.coalesce() ? n.drawCoalesced(t) : n.drawPerEntry(t);
			}
		}), e.add(this.konvaShape);
	}
	drawPerEntry(e) {
		let t = e.getTransform(), n = t.a, r = t.b, i = t.c, a = t.d;
		for (let o of this.entries) {
			if (!o.visible) continue;
			let s = n * o.x + i * o.y + t.e, c = r * o.x + a * o.y + t.f;
			o.noScaling ? e.setTransform(75, 0, 0, 75, s, c) : e.setTransform(n, r, i, a, s, c);
			for (let t of o.commands) A(e, t);
		}
		e.setTransform(t);
	}
	drawCoalesced(e) {
		let t = e.getTransform();
		this.sweep(e, t, (e) => e.layer !== "room"), this.sweep(e, t, (e) => e.layer === "room"), e.setTransform(t);
	}
	sweep(e, t, n) {
		let r = t.a, i = t.b, a = t.c, o = t.d, s = t.e, c = t.f, l = this.buckets;
		l.clear();
		for (let t of this.entries) {
			if (!t.visible || !n(t)) continue;
			let u = Ke(t);
			if (u === null) {
				let n = r * t.x + a * t.y + s, l = i * t.x + o * t.y + c;
				t.noScaling ? e.setTransform(75, 0, 0, 75, n, l) : e.setTransform(r, i, a, o, n, l);
				for (let n of t.commands) A(e, n);
			} else {
				let e = l.get(u);
				e || l.set(u, e = []), e.push(t);
			}
		}
		if (l.size !== 0) {
			e.setTransform(r, i, a, o, s, c);
			for (let t of l.values()) {
				let n = t[0].commands[0];
				if (e.beginPath(), n.type === "rect") {
					let r = n.cr > 0 && typeof e.roundRect == "function";
					for (let i of t) r ? e.roundRect(i.x + n.x, i.y + n.y, n.w, n.h, n.cr) : e.rect(i.x + n.x, i.y + n.y, n.w, n.h);
					n.fill && (e.fillStyle = n.fill, e.fill()), n.stroke && n.sw > 0 && (e.strokeStyle = n.stroke, e.lineWidth = n.sw, e.setLineDash([]), e.stroke());
				} else if (n.type === "circle") {
					for (let r of t) {
						let t = r.x + n.cx, i = r.y + n.cy;
						e.moveTo(t + n.r, i), e.arc(t, i, n.r, 0, Math.PI * 2);
					}
					n.fill && (e.fillStyle = n.fill, e.fill()), n.stroke && n.sw > 0 && (e.strokeStyle = n.stroke, e.lineWidth = n.sw, e.setLineDash([]), e.stroke());
				} else if (n.type === "line") {
					for (let n of t) {
						let t = n.commands[0].points;
						if (!(t.length < 4)) {
							e.moveTo(t[0] + n.x, t[1] + n.y);
							for (let r = 2; r < t.length; r += 2) e.lineTo(t[r] + n.x, t[r + 1] + n.y);
						}
					}
					n.stroke && (e.strokeStyle = n.stroke), e.lineWidth = n.sw, e.setLineDash([]), n.lineCap && (e.lineCap = n.lineCap), n.lineJoin && (e.lineJoin = n.lineJoin), e.stroke();
				}
			}
		}
	}
	addNode(e) {
		let t = {
			x: e.x,
			y: e.y,
			noScaling: e.noScaling,
			layer: e.layer,
			commands: e.commands,
			visible: e._visible
		};
		this.entries.push(t), this.nodeToEntry.set(e, t), this.ensureShape();
	}
	getEntry(e) {
		return this.nodeToEntry.get(e);
	}
	destroyChildren() {
		this.entries.length = 0, this.nodeToEntry.clear();
	}
	batchDraw() {
		this.konvaLayer.batchDraw();
	}
	ensureShape() {
		this.konvaShape.getParent() || this.konvaLayer.add(this.konvaShape);
	}
}, j = class {
	constructor(e) {
		this.groups = [], this.konvaLayer = e, e.destroyChildren();
		let t = this;
		this.konvaShape = new D.Shape({
			listening: !1,
			perfectDrawEnabled: !1,
			sceneFunc: (e) => {
				let n = e._context, r = n.getTransform(), i = r.a, a = r.b, o = r.c, s = r.d;
				for (let e of t.groups) {
					if (!e._visible) continue;
					let t = i * e.x + o * e.y + r.e, c = a * e.x + s * e.y + r.f;
					e.noScaling ? n.setTransform(75, 0, 0, 75, t, c) : n.setTransform(i, a, o, s, t, c);
					for (let t of e.commands) A(n, t);
				}
				n.setTransform(r);
			}
		}), e.add(this.konvaShape);
	}
	addNode(e) {
		this.groups.push(e), this.ensureShape();
	}
	destroyChildren() {
		this.groups.length = 0;
	}
	batchDraw() {
		this.konvaLayer.batchDraw();
	}
	ensureShape() {
		this.konvaShape.getParent() || this.konvaLayer.add(this.konvaShape);
	}
}, Je = class {
	constructor(e) {
		this.konvaLayer = e;
	}
	addNode(e) {
		this.konvaLayer.add(e.materialize());
	}
	destroyChildren() {
		this.konvaLayer.destroyChildren();
	}
	batchDraw() {
		this.konvaLayer.batchDraw();
	}
};
//#endregion
//#region src/scene/Shape.ts
function Ye(e) {
	return typeof e == "object" && !!e;
}
function Xe(e, t) {
	return t !== !1 && e ? e : void 0;
}
function M(e, t, n, r, i, a) {
	return Ye(e) ? e.type === "linear" ? {
		type: "linear",
		x0: (t + e.x0) * r + i,
		y0: (n + e.y0) * r + a,
		x1: (t + e.x1) * r + i,
		y1: (n + e.y1) * r + a,
		stops: e.stops
	} : {
		type: "radial",
		cx: (t + e.cx) * r + i,
		cy: (n + e.cy) * r + a,
		r: e.r * r,
		fx: e.fx === void 0 ? void 0 : (t + e.fx) * r + i,
		fy: e.fy === void 0 ? void 0 : (n + e.fy) * r + a,
		fr: e.fr === void 0 ? void 0 : e.fr * r,
		stops: e.stops
	} : e;
}
//#endregion
//#region src/render/shapeToRecording.ts
function Ze(e) {
	let t = new Ge(e.x, e.y);
	return e.noScale && (t.noScaling = !0), t.layer = e.layer, Qe(t, e.children, 0, 0), t;
}
function Qe(e, t, n, r) {
	for (let i of t) $e(e, i, n, r);
}
function $e(e, t, n, r) {
	switch (t.type) {
		case "rect":
			e.commands.push({
				type: "rect",
				x: t.x + n,
				y: t.y + r,
				w: t.width,
				h: t.height,
				fill: M(t.paint.fill, n, r, 1, 0, 0),
				stroke: t.paint.stroke,
				sw: t.paint.strokeWidth ?? 0,
				cr: t.cornerRadius ?? 0,
				dash: Xe(t.paint.dash, t.paint.dashEnabled)
			});
			return;
		case "circle":
			e.commands.push({
				type: "circle",
				cx: t.cx + n,
				cy: t.cy + r,
				r: t.radius,
				fill: M(t.paint.fill, n, r, 1, 0, 0),
				stroke: t.paint.stroke,
				sw: t.paint.strokeWidth ?? 0,
				dash: Xe(t.paint.dash, t.paint.dashEnabled)
			});
			return;
		case "line": {
			let i = n === 0 && r === 0 ? t.points : et(t.points, n, r);
			e.commands.push({
				type: "line",
				points: i,
				stroke: t.paint.stroke,
				sw: t.paint.strokeWidth ?? 0,
				dash: Xe(t.paint.dash, t.paint.dashEnabled),
				lineCap: t.lineCap,
				lineJoin: t.lineJoin,
				alpha: t.paint.alpha
			});
			return;
		}
		case "polygon":
			e.commands.push({
				type: "polygon",
				vertices: n === 0 && r === 0 ? t.vertices : et(t.vertices, n, r),
				fill: M(t.paint.fill, n, r, 1, 0, 0),
				stroke: t.paint.stroke,
				sw: t.paint.strokeWidth ?? 0
			});
			return;
		case "text":
			e.commands.push({
				type: "text",
				x: t.x + n,
				y: t.y + r,
				text: t.text,
				fontSize: t.fontSize,
				fontFamily: t.fontFamily ?? "sans-serif",
				fontStyle: t.fontStyle ?? "normal",
				fill: t.fill ?? "black",
				stroke: t.stroke,
				sw: t.strokeWidth ?? 0,
				align: t.align ?? "left",
				vAlign: t.verticalAlign ?? "top",
				w: t.width ?? 0,
				h: t.height ?? 0,
				baselineRatio: t.baselineRatio,
				transform: t.transform
			});
			return;
		case "image": {
			let i = tt(t.src);
			e.commands.push({
				type: "image",
				x: t.x + n,
				y: t.y + r,
				w: t.width,
				h: t.height,
				image: i,
				transform: t.transform
			});
			return;
		}
		case "group":
			Qe(e, t.children, n + t.x, r + t.y);
			return;
	}
}
function et(e, t, n) {
	let r = Array(e.length);
	for (let i = 0; i < e.length; i += 2) r[i] = e[i] + t, r[i + 1] = e[i + 1] + n;
	return r;
}
function tt(e) {
	let t = D === void 0 ? typeof Image < "u" ? new Image() : null : D.Util.createImageElement();
	return t && (t.src = e), t;
}
//#endregion
//#region src/reader/ViewportDataSource.ts
function N(e) {
	return !!e && e.viewportAware === !0;
}
//#endregion
//#region src/rendering/lod/RasterOverview.ts
function nt(e, t = 1) {
	let n = Math.ceil(e) + 1, r = Math.ceil(e * t) + 1;
	return Math.max(1, Math.min(48, Math.max(n, r)));
}
function rt(e, t, n) {
	let r = e.width, i = e.height, a = new Uint32Array(e.data.buffer), o = nt(n.scale, n.roomSize), s = o >> 1;
	t((e, t, c) => {
		let l = Math.round(e * n.scale + n.offsetX) - s, u = Math.round(t * n.scale + n.offsetY) - s, d = n.colorOf(c);
		for (let e = 0; e < o; e++) {
			let t = u + e;
			if (t < 0 || t >= i) continue;
			let n = t * r;
			for (let e = 0; e < o; e++) {
				let t = l + e;
				t >= 0 && t < r && (a[n + t] = d);
			}
		}
	});
}
function it(e) {
	let t = e.trim(), n = 0, r = 0, i = 0;
	if (t[0] === "#") t.length === 4 ? (n = parseInt(t[1] + t[1], 16), r = parseInt(t[2] + t[2], 16), i = parseInt(t[3] + t[3], 16)) : (n = parseInt(t.slice(1, 3), 16), r = parseInt(t.slice(3, 5), 16), i = parseInt(t.slice(5, 7), 16));
	else {
		let e = t.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
		e && (n = +e[1], r = +e[2], i = +e[3]);
	}
	return (255 << 24 | i << 16 | r << 8 | n) >>> 0;
}
//#endregion
//#region src/rendering/lod/LodController.ts
var at = .25, ot = 8192, st = class {
	constructor(e, t, n, r) {
		this.layer = e, this.camera = t, this.colorCss = n, this.roomSizeOf = r, this.visit = null, this.paintedRegion = null, this.paintedScale = 0, this.repaintScheduled = !1, this.destroyed = !1, this.packedCache = /* @__PURE__ */ new Map(), this.colorOf = (e) => {
			let t = this.packedCache.get(e);
			return t === void 0 && (t = it(this.colorCss(e)), this.packedCache.set(e, t)), t;
		}, this.canvas = D.Util.createCanvasElement(), this.layer.visible(!1);
	}
	setSource(e) {
		this.visit = e, this.packedCache.clear(), this.paint();
	}
	clear() {
		this.visit === null && !this.layer.visible() || (this.visit = null, this.paintedRegion = null, this.layer.visible(!1), this.layer.batchDraw());
	}
	onViewportChange() {
		if (!this.visit || this.repaintScheduled) return;
		let e = this.paintedRegion;
		if (e && this.camera.getScale() === this.paintedScale) {
			let t = this.camera.getViewportBounds();
			if (t.minX >= e.minX && t.maxX <= e.maxX && t.minY >= e.minY && t.maxY <= e.maxY) return;
		}
		this.repaintScheduled = !0;
		let t = () => {
			this.repaintScheduled = !1, !this.destroyed && this.visit && this.paint();
		};
		typeof requestAnimationFrame < "u" ? requestAnimationFrame(t) : queueMicrotask(t);
	}
	destroy() {
		this.destroyed = !0, this.visit = null;
	}
	paint() {
		let e = this.visit;
		if (!e) return;
		let t = this.camera.getViewportBounds(), n = this.camera.getScale(), r = (t.maxX - t.minX) * at, i = (t.maxY - t.minY) * at, a = {
			minX: t.minX - r,
			maxX: t.maxX + r,
			minY: t.minY - i,
			maxY: t.maxY + i
		}, o = Math.min(ot, Math.max(1, Math.ceil((a.maxX - a.minX) * n))), s = Math.min(ot, Math.max(1, Math.ceil((a.maxY - a.minY) * n)));
		this.canvas.width = o, this.canvas.height = s;
		let c = this.canvas.getContext("2d"), l = c.createImageData(o, s);
		rt(l, (t) => e(a, t), {
			scale: n,
			offsetX: -a.minX * n,
			offsetY: -a.minY * n,
			colorOf: this.colorOf,
			roomSize: this.roomSizeOf()
		}), c.putImageData(l, 0, 0), this.image ? this.image.image(this.canvas) : (this.image = new D.Image({
			image: this.canvas,
			listening: !1
		}), this.layer.add(this.image)), this.image.position({
			x: a.minX,
			y: a.minY
		}), this.image.size({
			width: a.maxX - a.minX,
			height: a.maxY - a.minY
		}), this.paintedRegion = a, this.paintedScale = n, this.layer.visible(!0), this.layer.batchDraw();
	}
};
//#endregion
//#region src/rendering/lod/lodDecision.ts
function ct(e) {
	return e.planeRoomCount > e.roomBudget && e.scale * e.scale < e.stageWidth * e.stageHeight / e.roomBudget;
}
function lt(e) {
	return ct({
		...e,
		roomBudget: e.roomBudget
	}) ? "raster" : e.exitBudget !== void 0 && ct({
		...e,
		roomBudget: e.exitBudget
	}) ? "roomsOnly" : "vector";
}
//#endregion
//#region src/rendering/lod/roomsOnlyArea.ts
function ut(e) {
	return {
		getAreaName: () => e.getAreaName(),
		getAreaId: () => e.getAreaId(),
		getVersion: () => e.getVersion(),
		getPlane: (t) => e.getPlane(t),
		getPlanes: () => e.getPlanes(),
		getZLevels: () => e.getZLevels(),
		getRooms: () => e.getRooms(),
		getFullBounds: () => e.getFullBounds(),
		getLinkExits: () => []
	};
}
//#endregion
//#region src/rendering/KonvaRenderBackend.ts
var P = "rgb(120, 72, 0)", dt = .5, ft = (1 + 2 * dt) ** 2, pt = class {
	get coordinateTransform() {
		return this._coordinateTransform;
	}
	constructor(t, n) {
		this.gridCachedBounds = null, this.currentStyle = x, this.hitTester = new ce(), this.lastHitShapes = [], this.shapeToDrawEntry = /* @__PURE__ */ new Map(), this.lastVisibleShapes = /* @__PURE__ */ new Set(), this.shapeToGroup = /* @__PURE__ */ new Map(), this.highlightShapes = /* @__PURE__ */ new Map(), this.pathShapes = [], this.spilledRoomPositions = /* @__PURE__ */ new Map(), this.currentRoomOverlay = [], this.destroyed = !1, this._coordinateTransform = e, this.coordinateInverse = e, this.liveEffects = /* @__PURE__ */ new Map(), this.sceneOverlays = /* @__PURE__ */ new Map(), this.sceneOverlayNodes = /* @__PURE__ */ new Map(), this.viewportSubscribers = /* @__PURE__ */ new Set(), this.lodMode = "vector", this.lastAppliedViewport = null, this.lastAppliedScale = null, this.refreshScheduled = !1, this.state = t, this.container = n, n ? (this.stage = new D.Stage({
			container: n,
			width: n.clientWidth,
			height: n.clientHeight,
			draggable: !1
		}), n.style.backgroundColor = t.settings.backgroundColor, this.camera = new T(n.clientWidth, n.clientHeight)) : (this.stage = new D.Stage({
			width: 1,
			height: 1
		}), this.camera = new T(1, 1)), this.lodLayer = new D.Layer({ listening: !1 }), this.stage.add(this.lodLayer), this.gridLayer = new D.Layer({ listening: !1 }), this.stage.add(this.gridLayer);
		let r = new D.Layer({ listening: !1 });
		if (this.linkLayer = r, this.roomLayer = r, this.stage.add(r), this.positionLayer = new D.Layer({ listening: !1 }), this.stage.add(this.positionLayer), this.overlayLayer = new D.Layer({ listening: !1 }), this.stage.add(this.overlayLayer), this.topLabelLayer = new D.Layer({ listening: !1 }), this.stage.add(this.topLabelLayer), this.positionLayerNode = new Je(this.positionLayer), this.overlayLayerNode = new Je(this.overlayLayer), this.sceneNode = new qe(r, () => t.settings.coalesceRooms), this.gridLayerNode = new j(this.gridLayer), this.topLabelLayerNode = new j(this.topLabelLayer), this.sceneManager = new We(this.camera, t.settings, t.mapReader), this.lodController = new st(this.lodLayer, this.camera, (e) => this.state.mapReader.getColorValue(e), () => this.state.settings.roomSize), this.events = new p(n), this.culling = new ie(t.settings, () => this.applyClipping()), this.cameraChangeHandler = () => this.applyViewportToStage(), this.camera.on("change", this.cameraChangeHandler), n) {
			this.origSetSize = this.camera.setSize.bind(this.camera);
			let e = this.origSetSize;
			this.camera.setSize = (t, n) => {
				e(t, n), this.stage.width(t), this.stage.height(n);
			}, this.interactionHandler = new oe(n, this.camera, t, {
				clientToMapPoint: (e, t) => this.camera.clientToMapPoint(e, t, n.getBoundingClientRect()),
				pickAtPoint: (e, t) => this.hitTester.pick(e, t)
			}, this.events);
		}
		this.applyStyleTransforms(), this.subscribeToState(t);
	}
	setStyle(e) {
		this.currentStyle = e, this.sceneNode = new qe(this.linkLayer, () => this.state.settings.coalesceRooms), this.gridLayerNode = new j(this.gridLayer), this.topLabelLayerNode = new j(this.topLabelLayer), this.gridCachedBounds = null, this.sceneManager.resetPipeline(this.state.mapReader), this.shapeToDrawEntry = /* @__PURE__ */ new Map(), this.shapeToGroup.clear(), this.lastHitShapes = [], this.hitTester.clear(), this.applyStyleTransforms(), this.refresh();
	}
	applyStyleTransforms() {
		let t = this.currentStyle, n = t.worldToScene ? (e, n) => t.worldToScene(e, n) : e, r = t.sceneToWorld ? (e, n) => t.sceneToWorld(e, n) : e, i = this.coordinateInverse, a = t.sceneLayerOffset ? (e) => t.sceneLayerOffset(e) : void 0;
		this._coordinateTransform = n, this.coordinateInverse = r, this.coordinateLayerOffset = a, this.culling.setCoordinateTransform(n), this.gridCachedBounds = null, this.lastHitShapes.length > 0 && (this.hitTestBudgetExceeded() ? this.hitTester.clear() : this.hitTester.build(this.lastHitShapes, this.state.settings.roomSize, n, a));
		let o = this.camera.getScale(), s = this.camera.width / 2, c = this.camera.height / 2, l = i((s - this.camera.position.x) / o, (c - this.camera.position.y) / o), u = n(l.x, l.y);
		this.camera.position = {
			x: s - u.x * o,
			y: c - u.y * o
		}, this.applyViewportToStage();
	}
	styleContext() {
		return {
			scale: this.camera.getScale(),
			roomSize: this.state.settings.roomSize
		};
	}
	mapPoint(e, t) {
		return this._coordinateTransform(e, t);
	}
	get exitRenderer() {
		return this.sceneManager.exitRenderer;
	}
	getDrawnExits() {
		return this.sceneManager.drawnExits;
	}
	getDrawnSpecialExits() {
		return this.sceneManager.drawnSpecialExits;
	}
	getDrawnStubs() {
		return this.sceneManager.drawnStubs;
	}
	destroy() {
		if (!this.destroyed) {
			this.destroyed = !0, this.state.events.removeAllListeners(), this.interactionHandler?.destroy();
			for (let e of this.liveEffects.values()) e.destroy();
			this.liveEffects.clear();
			for (let e of this.sceneOverlays.values()) e.detach?.();
			this.sceneOverlays.clear();
			for (let e of this.sceneOverlayNodes.values()) for (let t of e) t.destroy();
			this.sceneOverlayNodes.clear(), this.viewportSubscribers.clear(), this.camera.cancelAnimation(), this.lodController.destroy(), this.origSetSize && (this.camera.setSize = this.origSetSize), this.cameraChangeHandler &&= (this.camera.off("change", this.cameraChangeHandler), void 0), this.clearOverlayShapes(), this.clearCurrentRoomOverlay(), this.positionMarker &&= (this.positionMarker.destroy(), void 0), this.stage.destroy(), this.events.removeAllListeners();
		}
	}
	updateBackground() {
		this.container && (this.container.style.backgroundColor = this.state.settings.backgroundColor);
	}
	exportCanvas(e) {
		if (this.state.currentArea === void 0 || this.state.currentZIndex === void 0) return;
		let t = this.stage.toCanvas({ pixelRatio: e?.pixelRatio ?? 1 }), n = document.createElement("canvas");
		n.width = t.width, n.height = t.height;
		let r = n.getContext("2d");
		return r.fillStyle = this.state.settings.backgroundColor, r.fillRect(0, 0, n.width, n.height), r.drawImage(t, 0, 0), n;
	}
	applyViewportToStage() {
		let e = this.camera.getScale();
		this.stage.scale({
			x: e,
			y: e
		}), this.stage.position(this.camera.position), this.stage.batchDraw();
		let t = this.camera.getViewportBounds();
		this.refreshGrid(t), this.culling.scheduleCulling(), this.onCameraViewportChanged(t), this.events.emit("pan", t);
		for (let e of this.viewportSubscribers) e();
		for (let n of this.liveEffects.values()) n.updateViewport(t, e, this.coordinateTransform);
	}
	onCameraViewportChanged(e) {
		let { currentAreaInstance: t, currentZIndex: n } = this.state;
		if (t && n !== void 0 && this.hasRealViewport()) {
			let t = this.state.settings.lodEnabled && this.computeLodMode() !== this.lodMode;
			if (!t && N(this.state.mapReader)) {
				let n = this.lastAppliedViewport, r = this.lastAppliedScale, i = this.camera.getScale();
				t = !n || r === null || e.minX < n.minX || e.maxX > n.maxX || e.minY < n.minY || e.maxY > n.maxY || i > r * 1.2 || i < r / 1.2;
			}
			t && this.scheduleRefresh();
		}
		this.lodController.onViewportChange();
	}
	scheduleRefresh() {
		if (this.refreshScheduled) return;
		this.refreshScheduled = !0;
		let e = () => {
			this.refreshScheduled = !1, this.destroyed || this.refresh();
		};
		typeof requestAnimationFrame < "u" ? requestAnimationFrame(e) : queueMicrotask(e);
	}
	refresh() {
		let { currentAreaInstance: e, currentZIndex: t, positionRoomId: n } = this.state;
		if (!e || t === void 0) return;
		let r = e.getPlane(t);
		if (!r) {
			this.shapeToDrawEntry = /* @__PURE__ */ new Map(), this.sceneManager.reset(), this.hitTester.clear(), this.lastHitShapes = [], this.gridLayer.destroyChildren(), this.linkLayer.destroyChildren(), this.positionLayer.destroyChildren(), this.positionMarker = void 0, this.clearOverlayShapes(), this.currentRoomOverlay = [], this.lodController.clear(), this.lodMode = "vector", this.stage.batchDraw();
			return;
		}
		this.updateBackground();
		let i = this.state.mapReader;
		if (N(i) && this.hasRealViewport()) {
			let e = this.padViewport(this.camera.getViewportBounds()), t = He(e.minX, e.minY, e.maxX, e.maxY, this.coordinateInverse);
			i.setViewport(t), this.lastAppliedViewport = e, this.lastAppliedScale = this.camera.getScale();
		}
		let a = this.computeLodMode();
		if (this.lodMode = a, a === "raster") this.clearVectorScene(), this.lodController.setSource(this.rasterVisit(e, r, t));
		else {
			this.lodController.clear();
			let n = a === "roomsOnly" ? ut(e) : e;
			this.buildScene(n, r, t), this.onSceneBuilt();
		}
		this.syncHighlights(), this.syncPaths(), n !== void 0 && this.onPositionChanged(n, !1, !1);
		for (let [e, t] of this.sceneOverlays) this.renderSceneOverlay(e, t);
		this.emitLodEvent(a, e, r, t);
	}
	hasRealViewport() {
		return this.camera.width > 1 || this.camera.height > 1;
	}
	padViewport(e) {
		let t = (e.maxX - e.minX) * dt + 1, n = (e.maxY - e.minY) * dt + 1;
		return {
			minX: e.minX - t,
			maxX: e.maxX + t,
			minY: e.minY - n,
			maxY: e.maxY + n
		};
	}
	planeRoomCount(e, t, n) {
		let r = this.state.mapReader;
		return N(r) ? r.getPlaneRoomCount(e.getAreaId(), n) : t.getRooms().length;
	}
	computeLodMode() {
		let e = this.state.settings;
		if (!e.lodEnabled || !this.hasRealViewport()) return "vector";
		let { currentAreaInstance: t, currentZIndex: n } = this.state;
		if (!t || n === void 0) return "vector";
		let r = t.getPlane(n);
		return r ? lt({
			planeRoomCount: this.planeRoomCount(t, r, n),
			scale: this.camera.getScale(),
			stageWidth: this.camera.width,
			stageHeight: this.camera.height,
			roomBudget: e.lodRoomBudget / ft,
			exitBudget: e.lodExitBudget / ft
		}) : "vector";
	}
	rasterVisit(e, t, n) {
		let r = this.state.mapReader;
		if (N(r)) {
			let t = e.getAreaId();
			return (e, i) => r.forEachInBounds(t, n, e, i);
		}
		return (e, n) => {
			for (let r of t.getRooms()) r.x >= e.minX && r.x <= e.maxX && r.y >= e.minY && r.y <= e.maxY && n(r.x, r.y, r.env);
		};
	}
	clearVectorScene() {
		this.shapeToDrawEntry = /* @__PURE__ */ new Map(), this.shapeToGroup.clear(), this.sceneManager.reset(), this.hitTester.clear(), this.lastHitShapes = [], this.lastVisibleShapes = /* @__PURE__ */ new Set(), this.spilledRoomPositions = /* @__PURE__ */ new Map(), this.sceneNode.destroyChildren(), this.topLabelLayerNode.destroyChildren(), this.stage.batchDraw();
	}
	hitTestBudgetExceeded() {
		if (!this.state.settings.lodEnabled) return !1;
		let { currentAreaInstance: e, currentZIndex: t } = this.state;
		if (!e || t === void 0) return !1;
		let n = e.getPlane(t);
		return n ? n.getRooms().length > this.state.settings.lodHitTestBudget : !1;
	}
	emitLodEvent(e, t, n, r) {
		if (!this.state.settings.lodEnabled) return;
		let i = this.state.mapReader, a = this.planeRoomCount(t, n, r), o = this.lastAppliedViewport ?? this.camera.getViewportBounds(), s = N(i) ? i.estimateVisibleCount(t.getAreaId(), r, o) : a, c = e === "raster" ? !1 : !this.hitTestBudgetExceeded();
		this.events.emit("lod", {
			mode: e,
			planeRoomCount: a,
			visibleEstimate: s,
			hitTestActive: c
		});
	}
	addLiveEffect(e, t) {
		this.removeLiveEffect(e), t.attach(this.overlayLayer), this.liveEffects.set(e, t), t.updateViewport(this.camera.getViewportBounds(), this.camera.getScale(), this.coordinateTransform);
	}
	removeLiveEffect(e) {
		let t = this.liveEffects.get(e);
		t && (t.destroy(), this.liveEffects.delete(e));
	}
	addSceneOverlay(e, t) {
		let n = this.sceneOverlays.get(e);
		n && (n.detach?.(), this.clearSceneOverlayNodes(e)), this.sceneOverlays.set(e, t), t.attach?.(this.createOverlayContext(e, t)), this.renderSceneOverlay(e, t);
	}
	removeSceneOverlay(e) {
		let t = this.sceneOverlays.get(e);
		t && (t.detach?.(), this.sceneOverlays.delete(e), this.clearSceneOverlayNodes(e), this.overlayLayer.batchDraw());
	}
	getSceneOverlays() {
		return this.sceneOverlays.values();
	}
	createOverlayContext(e, t) {
		return {
			state: this.state,
			onViewportChange: (e) => (this.viewportSubscribers.add(e), () => this.viewportSubscribers.delete(e)),
			invalidate: () => {
				this.sceneOverlays.get(e) === t && this.renderSceneOverlay(e, t);
			}
		};
	}
	renderSceneOverlay(e, t) {
		this.clearSceneOverlayNodes(e);
		let n = this.camera.getViewportBounds(), r = t.render(this.state, n);
		if (r) {
			let n = Array.isArray(r) ? r : [r], i = [];
			for (let e of n) {
				let n = this.addStyledShape(e, this.overlayLayerNode, t.sceneSpace);
				n && i.push(n);
			}
			this.sceneOverlayNodes.set(e, i);
		}
		this.overlayLayer.batchDraw();
	}
	clearSceneOverlayNodes(e) {
		let t = this.sceneOverlayNodes.get(e);
		if (t) {
			for (let e of t) e.destroy();
			this.sceneOverlayNodes.delete(e);
		}
	}
	subscribeToState(e) {
		e.events.on("area", () => {
			this.refresh();
		}), e.events.on("position", ({ roomId: e, center: t, areaChanged: n }) => {
			this.onPositionChanged(e, t, n), this.state.settings.neighborSpill && e !== void 0 && this.refresh();
		}), e.events.on("center", ({ roomId: t, instant: n }) => {
			let r = e.mapReader.getRoom(t);
			if (r) {
				let e = this.mapPoint(r.x, r.y);
				this.camera.panToMapPointAnimated(e.x, e.y, n || this.state.settings.instantMapMove);
			}
		}), e.events.on("highlight", ({ roomId: e, colors: t }) => {
			this.syncHighlight(e, t);
		}), e.events.on("path", () => {
			this.syncPaths();
		}), e.events.on("clear", () => {
			this.syncHighlights();
		}), e.events.on("lens", () => {
			this.refresh();
		});
	}
	buildScene(e, t, n) {
		this.positionLayer.destroyChildren(), this.positionMarker = void 0, this.clearOverlayShapes(), this.currentRoomOverlay = [], this.sceneNode.destroyChildren(), this.gridLayerNode.destroyChildren(), this.gridCachedBounds = null, this.topLabelLayerNode.destroyChildren();
		let r = this.computeNeighborSpill(e, n);
		this.spilledRoomPositions = r ? he(r) : /* @__PURE__ */ new Map();
		let i = this.sceneManager.rebuild(e, t, n, this.state.lens, r);
		this.shapeToGroup = /* @__PURE__ */ new Map(), this.refreshGrid(this.camera.getViewportBounds());
		for (let e of i.sceneShapes.link) {
			let t = this.addStyledShape(e, this.sceneNode);
			t && this.shapeToGroup.set(e, t);
		}
		for (let e of i.sceneShapes.room) {
			let t = this.addStyledShape(e, this.sceneNode);
			t && this.shapeToGroup.set(e, t);
		}
		for (let e of i.sceneShapes.topLabel) this.addStyledShape(e, this.topLabelLayerNode);
	}
	computeNeighborSpill(e, t) {
		let n = this.state.settings;
		if (!n.neighborSpill) return;
		let r = this.state.positionRoomId;
		if (r === void 0) return;
		let i = this.state.mapReader.getRoom(r);
		if (!i || i.area !== e.getAreaId() || i.z !== t) return;
		let a = this.state.lens;
		return b(this.state.mapReader, e.getAreaId(), t, r, n.neighborSpillDistance, (e) => a.isVisible(e));
	}
	overlayReader() {
		return this.spilledRoomPositions.size === 0 || this.state.currentArea === void 0 || this.state.currentZIndex === void 0 ? this.state.mapReader : new ne(this.state.mapReader, this.state.currentArea, this.state.currentZIndex, this.spilledRoomPositions);
	}
	addStyledShape(e, t, n = !1) {
		let r = n || this.currentStyle === x ? [e] : E([e], this.currentStyle, this.styleContext());
		if (r.length === 0) return;
		let i;
		i = r.length === 1 && r[0].type === "group" ? r[0] : {
			type: "group",
			x: 0,
			y: 0,
			children: r,
			layer: e.layer,
			noScale: e.noScale
		};
		let a = Ze(i);
		return t.addNode(a), a;
	}
	refreshGrid(e) {
		let t = this.state.settings;
		if (!t.gridEnabled) {
			this.gridCachedBounds !== null && (this.gridLayerNode.destroyChildren(), this.gridLayerNode.batchDraw(), this.gridCachedBounds = null);
			return;
		}
		let n = this.coordinateInverse, r = n(e.minX, e.minY), i = n(e.maxX, e.minY), a = n(e.maxX, e.maxY), o = n(e.minX, e.maxY), s = Math.min(r.x, i.x, a.x, o.x), c = Math.max(r.x, i.x, a.x, o.x), l = Math.min(r.y, i.y, a.y, o.y), u = Math.max(r.y, i.y, a.y, o.y), d = t.gridSize * 2, f = Math.floor((s - d) / t.gridSize) * t.gridSize, p = Math.ceil((c + d) / t.gridSize) * t.gridSize, m = Math.floor((l - d) / t.gridSize) * t.gridSize, h = Math.ceil((u + d) / t.gridSize) * t.gridSize, g = this.gridCachedBounds;
		if (g && g.left === f && g.right === p && g.top === m && g.bottom === h) return;
		this.gridLayerNode.destroyChildren();
		let _ = Ne(e, t, { inverseTransform: this.coordinateInverse });
		for (let e of _) this.addStyledShape(e, this.gridLayerNode);
		this.gridCachedBounds = {
			left: f,
			right: p,
			top: m,
			bottom: h
		}, this.gridLayerNode.batchDraw();
	}
	onSceneBuilt() {
		this.lastHitShapes = this.sceneManager.hitShapes, this.hitTestBudgetExceeded() ? this.hitTester.clear() : this.hitTester.build(this.lastHitShapes, this.state.settings.roomSize, this._coordinateTransform, this.coordinateLayerOffset);
		let e = this.camera.getScale();
		this.stage.scale({
			x: e,
			y: e
		}), this.shapeToDrawEntry = /* @__PURE__ */ new Map();
		for (let [e, t] of this.shapeToGroup) {
			let n = this.sceneNode.getEntry(t);
			n && this.shapeToDrawEntry.set(e, n);
		}
		this.lastVisibleShapes = this.sceneManager.managedShapes(this._coordinateTransform), this.applyClipping(), this.stage.batchDraw();
	}
	applyClipping() {
		if (!this.sceneManager.lastResult) return;
		let e = this.sceneManager.cullInteractive(this._coordinateTransform), t = this.lastVisibleShapes, n = !1;
		for (let r of t) {
			if (e.has(r)) continue;
			let t = this.shapeToDrawEntry.get(r);
			t && t.visible && (t.visible = !1, n = !0);
		}
		for (let r of e) {
			if (t.has(r)) continue;
			let e = this.shapeToDrawEntry.get(r);
			e && !e.visible && (e.visible = !0, n = !0);
		}
		this.lastVisibleShapes = e, n && this.sceneNode.batchDraw();
	}
	onPositionChanged(e, t, n) {
		if (e === void 0) {
			this.positionMarker &&= (this.positionMarker.destroy(), void 0), this.positionLayerNode.batchDraw(), this.clearCurrentRoomOverlay(), this.overlayLayerNode.batchDraw();
			return;
		}
		let r = this.state.mapReader.getRoom(e);
		if (r) {
			if (t) {
				let e = this.mapPoint(r.x, r.y);
				this.camera.panToMapPointAnimated(e.x, e.y, n || this.state.settings.instantMapMove);
			}
			this.updateCurrentRoomOverlay(r), this.applyPositionMarker(r);
		}
	}
	applyPositionMarker(e) {
		if (this.positionMarker &&= (this.positionMarker.destroy(), void 0), e.area !== this.state.currentArea || e.z !== this.state.currentZIndex) {
			this.positionLayerNode.batchDraw();
			return;
		}
		let t = te(e, this.state.settings);
		this.positionMarker = this.addStyledShape(ae(t), this.positionLayerNode);
	}
	clearCurrentRoomOverlay() {
		this.currentRoomOverlay.forEach((e) => e.destroy()), this.currentRoomOverlay = [], this.positionLayerNode.batchDraw();
	}
	updateCurrentRoomOverlay(e) {
		if (this.clearCurrentRoomOverlay(), e.area !== this.state.currentArea || e.z !== this.state.currentZIndex) {
			this.positionLayerNode.batchDraw();
			return;
		}
		let r = this.state.settings;
		if (this.lodMode === "raster") {
			this.positionMarker && this.positionMarker.moveToTop(), this.positionLayerNode.batchDraw();
			return;
		}
		if (!r.highlightCurrentRoom) {
			this.positionMarker && this.positionMarker.moveToTop(), this.positionLayerNode.batchDraw();
			return;
		}
		let a = /* @__PURE__ */ new Map();
		a.set(e.id, e);
		let o = [], s = this.sceneManager.exitRenderer, c = S(this.state.lens, r.hiddenRooms === "hide");
		this.state.currentAreaInstance && this.state.currentZIndex !== void 0 && this.state.currentAreaInstance.getLinkExits(this.state.currentZIndex).filter((t) => t.a === e.id || t.b === e.id).forEach((e) => {
			let t = this.state.mapReader.getRoom(e.a), n = this.state.mapReader.getRoom(e.b);
			if (!t || !n || (c.getExitTreatment ? c.getExitTreatment(e, t, n) : d(c, e, t, n)) !== "full") return;
			let r = s.renderDataWithColor(e, P, this.state.currentZIndex);
			if (r) {
				if (r.targetRoomId !== void 0 && this.spilledRoomPositions.has(r.targetRoomId)) return;
				o.push(this.sceneManager.buildExitShape(r));
			}
		});
		for (let t of g(e, r, P)) o.push(h(t, e.id));
		for (let t of i(e, r, P)) o.push(me(t));
		[...Object.values(e.exits), ...Object.values(e.specialExits)].forEach((e) => {
			let t = this.state.mapReader.getRoom(e);
			t && t.area === this.state.currentArea && t.z === this.state.currentZIndex && c.isVisible(t) && a.set(e, t);
		}), o.forEach((e) => {
			let t = this.addStyledShape(e, this.positionLayerNode);
			t && this.currentRoomOverlay.push(t);
		}), a.forEach((i, a) => {
			let o = a === e.id, s = pe(i, this.state.mapReader, r, {
				strokeOverride: o ? P : r.lineColor,
				flatPipeline: !0,
				...t(i, r.hiddenRooms)
			});
			s.children.push(...n(i, this.state.mapReader, r));
			let c = this.addStyledShape(s, this.positionLayerNode);
			c && this.currentRoomOverlay.push(c);
		}), this.positionMarker && this.positionMarker.moveToTop(), this.positionLayerNode.batchDraw();
	}
	syncHighlight(e, t) {
		let n = this.highlightShapes.get(e);
		if (n && (n.destroy(), this.highlightShapes.delete(e)), t !== void 0) {
			let n = this.overlayReader().getRoom(e);
			if (n && n.area === this.state.currentArea && n.z === this.state.currentZIndex) {
				let r = de(n, t, this.state.settings), i = this.addStyledShape(ue(r), this.overlayLayerNode);
				i && this.highlightShapes.set(e, i);
			}
		}
		this.overlayLayerNode.batchDraw();
	}
	syncHighlights() {
		for (let e of this.highlightShapes.values()) e.destroy();
		this.highlightShapes.clear();
		let e = this.overlayReader();
		for (let [t] of this.state.highlights) {
			let n = e.getRoom(t);
			if (!n || n.area !== this.state.currentArea || n.z !== this.state.currentZIndex) continue;
			let r = de(n, this.state.highlights.get(t).colors, this.state.settings), i = this.addStyledShape(ue(r), this.overlayLayerNode);
			i && this.highlightShapes.set(t, i);
		}
		this.overlayLayerNode.batchDraw();
	}
	syncPaths() {
		this.clearPathShapes();
		let { currentArea: e, currentZIndex: t } = this.state;
		if (e === void 0 || t === void 0) return;
		let n = this.overlayReader();
		for (let r of this.state.paths) {
			let i = ee(n, this.state.settings, r.locations, r.color, e, t);
			for (let e of C(i)) {
				let t = this.addStyledShape(e, this.overlayLayerNode);
				t && this.pathShapes.push(t);
			}
		}
		this.overlayLayerNode.batchDraw();
	}
	clearOverlayShapes() {
		for (let e of this.highlightShapes.values()) e.destroy();
		this.highlightShapes.clear(), this.clearPathShapes();
	}
	clearPathShapes() {
		for (let e of this.pathShapes) e.destroy();
		this.pathShapes = [];
	}
};
//#endregion
//#region src/style/shape/paintMap.ts
function F(e, t) {
	if (e !== void 0) return typeof e == "string" ? t(e) : {
		...e,
		stops: e.stops.map((e) => ({
			offset: e.offset,
			color: t(e.color)
		}))
	};
}
function I(e) {
	let t = e.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/);
	return t ? {
		r: parseInt(t[1]),
		g: parseInt(t[2]),
		b: parseInt(t[3]),
		a: t[4] === void 0 ? 1 : parseFloat(t[4])
	} : e.startsWith("#") && e.length >= 7 ? {
		r: parseInt(e.slice(1, 3), 16),
		g: parseInt(e.slice(3, 5), 16),
		b: parseInt(e.slice(5, 7), 16),
		a: 1
	} : null;
}
function L(e, t, n, r = 1) {
	return r < 1 ? `rgba(${e}, ${t}, ${n}, ${r})` : `rgb(${e}, ${t}, ${n})`;
}
function R(e) {
	return (.299 * e.r + .587 * e.g + .114 * e.b) / 255;
}
function mt(e, t, n) {
	e /= 255, t /= 255, n /= 255;
	let r = Math.max(e, t, n), i = Math.min(e, t, n), a = (r + i) / 2;
	if (r === i) return [
		0,
		0,
		a
	];
	let o = r - i, s = a > .5 ? o / (2 - r - i) : o / (r + i), c;
	return c = r === e ? ((t - n) / o + (t < n ? 6 : 0)) / 6 : r === t ? ((n - e) / o + 2) / 6 : ((e - t) / o + 4) / 6, [
		c * 360,
		s,
		a
	];
}
function ht(e, t, n, r = 1) {
	e = (e % 360 + 360) % 360;
	let i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(e / 60 % 2 - 1)), o = n - i / 2, s, c, l;
	return e < 60 ? (s = i, c = a, l = 0) : e < 120 ? (s = a, c = i, l = 0) : e < 180 ? (s = 0, c = i, l = a) : e < 240 ? (s = 0, c = a, l = i) : e < 300 ? (s = a, c = 0, l = i) : (s = i, c = 0, l = a), L(Math.round((s + o) * 255), Math.round((c + o) * 255), Math.round((l + o) * 255), r);
}
//#endregion
//#region src/style/shape/ParchmentStyle.ts
var gt = "#4a3728", _t = "#3b2a1a", vt = 139, yt = 115, bt = 85, xt = 244, St = 228, Ct = 193;
function wt(e) {
	let t = I(e);
	if (!t) return L(xt, St, Ct);
	let n = R(t);
	return L(Math.round(vt + (xt - vt) * n), Math.round(yt + (St - yt) * n), Math.round(bt + (Ct - bt) * n), t.a);
}
function Tt(e) {
	let t = I(e);
	if (!t || t.a >= 1) return gt;
	let n = I(gt);
	return L(n.r, n.g, n.b, t.a);
}
function Et(e) {
	return {
		...e,
		fill: F(e.fill, wt),
		stroke: e.stroke ? Tt(e.stroke) : e.stroke
	};
}
var Dt = { transform(e) {
	switch (e.type) {
		case "rect":
		case "circle":
		case "polygon": return {
			...e,
			paint: Et(e.paint)
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: Tt(e.paint.stroke)
			} : e.paint
		};
		case "text": return {
			...e,
			fill: _t
		};
		case "image":
		case "group": return e;
	}
} }, Ot = "#c0deff", kt = "#e0f0ff", At = 20, jt = 40, Mt = 80, Nt = 60, Pt = 100, Ft = 160;
function It(e) {
	let t = I(e);
	if (!t) return L(Nt, Pt, Ft);
	let n = R(t);
	return L(Math.round(At + (Nt - At) * n), Math.round(jt + (Pt - jt) * n), Math.round(Mt + (Ft - Mt) * n), t.a);
}
function Lt(e) {
	let t = I(e);
	if (!t || t.a >= 1) return Ot;
	let n = I(Ot);
	return L(n.r, n.g, n.b, t.a);
}
function Rt(e) {
	return {
		...e,
		fill: F(e.fill, It),
		stroke: e.stroke ? Lt(e.stroke) : e.stroke
	};
}
var zt = { transform(e) {
	switch (e.type) {
		case "rect":
		case "circle":
		case "polygon": return {
			...e,
			paint: Rt(e.paint)
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: Lt(e.paint.stroke)
			} : e.paint
		};
		case "text": return {
			...e,
			fill: kt
		};
		case "image":
		case "group": return e;
	}
} }, Bt = "#00ffd0", Vt = .3, Ht = 3;
function Ut(e, t, n) {
	e /= 255, t /= 255, n /= 255;
	let r = Math.max(e, t, n), i = Math.min(e, t, n), a = (r + i) / 2;
	if (r === i) return [
		0,
		0,
		a
	];
	let o = r - i, s = a > .5 ? o / (2 - r - i) : o / (r + i), c;
	return c = r === e ? ((t - n) / o + (t < n ? 6 : 0)) / 6 : r === t ? ((n - e) / o + 2) / 6 : ((e - t) / o + 4) / 6, [
		c * 360,
		s,
		a
	];
}
function z(e, t, n, r = 1) {
	e = (e % 360 + 360) % 360;
	let i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(e / 60 % 2 - 1)), o = n - i / 2, s, c, l;
	e < 60 ? (s = i, c = a, l = 0) : e < 120 ? (s = a, c = i, l = 0) : e < 180 ? (s = 0, c = i, l = a) : e < 240 ? (s = 0, c = a, l = i) : e < 300 ? (s = a, c = 0, l = i) : (s = i, c = 0, l = a);
	let u = Math.round((s + o) * 255), d = Math.round((c + o) * 255), f = Math.round((l + o) * 255);
	return r < 1 ? `rgba(${u}, ${d}, ${f}, ${r})` : `rgb(${u}, ${d}, ${f})`;
}
function Wt(e) {
	let t = I(e);
	if (!t) return {
		h: 150,
		a: 1
	};
	let [n] = Ut(t.r, t.g, t.b);
	return {
		h: n,
		a: t.a
	};
}
function Gt(e) {
	let { h: t, a: n } = Wt(e);
	return z(t, .95, .65, n);
}
function Kt(e) {
	let t = I(e);
	if (!t) return "rgb(8, 12, 10)";
	let [n] = Ut(t.r, t.g, t.b);
	return z(n, .4, .1, t.a);
}
function qt(e) {
	let { h: t, a: n } = Wt(e);
	return z(t, .95, .65, Math.min(n, Vt));
}
function Jt(e) {
	return {
		...e,
		fill: F(e.fill, Kt),
		stroke: e.stroke ? Gt(e.stroke) : e.stroke
	};
}
function Yt(e, t = !1) {
	if (!e.stroke) return e;
	let n = (e.strokeWidth ?? 1) * Ht;
	return {
		stroke: qt(e.stroke),
		strokeWidth: n,
		dash: e.dash,
		dashEnabled: e.dashEnabled,
		alpha: t ? Vt : e.alpha
	};
}
var Xt = { transform(e) {
	switch (e.type) {
		case "rect": {
			let t = {
				...e,
				paint: Jt(e.paint)
			};
			return e.paint.stroke ? [{
				...e,
				paint: {
					...Yt(e.paint),
					fill: void 0
				}
			}, t] : t;
		}
		case "circle": {
			let t = {
				...e,
				paint: Jt(e.paint)
			};
			return e.paint.stroke ? [{
				...e,
				paint: {
					...Yt(e.paint),
					fill: void 0
				}
			}, t] : t;
		}
		case "line": {
			let t = {
				...e,
				paint: e.paint.stroke ? {
					...e.paint,
					stroke: Gt(e.paint.stroke)
				} : e.paint
			};
			return e.paint.stroke ? [{
				...e,
				paint: Yt(e.paint, !0)
			}, t] : t;
		}
		case "polygon": return {
			...e,
			paint: Jt(e.paint)
		};
		case "text": return {
			...e,
			fill: Bt
		};
		case "image":
		case "group": return e;
	}
} };
//#endregion
//#region src/style/shape/wobble.ts
function B(e) {
	let t = e | 0 || 1;
	return () => (t = t * 1664525 + 1013904223 | 0, (t >>> 0) / 4294967296);
}
function V(...e) {
	let t = 2654435769;
	for (let n of e) t ^= (n * 1e3 | 0) + 2654435769 + (t << 6) + (t >> 2);
	return t;
}
function Zt(e, t, n, r, i, a) {
	let o = n - e, s = r - t, c = Math.sqrt(o * o + s * s);
	if (c < .001) return [
		e,
		t,
		n,
		r
	];
	let l = -s / c, u = o / c, d = Math.max(2, Math.min(6, Math.ceil(c / .15))), f = [e + l * (a() - .5) * i * .3, t + u * (a() - .5) * i * .3];
	for (let n = 1; n < d; n++) {
		let r = n / d, c = e + o * r, p = t + s * r, m = (a() - .5) * 2 * i;
		f.push(c + l * m, p + u * m);
	}
	return f.push(n + l * (a() - .5) * i * .3, r + u * (a() - .5) * i * .3), f;
}
function Qt(e, t, n) {
	if (e.length < 4) return e;
	let r = [];
	for (let i = 0; i < e.length - 2; i += 2) {
		let a = Zt(e[i], e[i + 1], e[i + 2], e[i + 3], t, n);
		if (i === 0) r.push(...a);
		else for (let e = 2; e < a.length; e++) r.push(a[e]);
	}
	return r;
}
function H(e, t, n, r, i, a) {
	let o = [
		e,
		t,
		e + n,
		t,
		e + n,
		t + r,
		e,
		t + r
	], s = [];
	for (let e = 0; e < 4; e++) {
		let t = o[e * 2], n = o[e * 2 + 1], r = (e + 1) % 4, c = o[r * 2], l = o[r * 2 + 1], u = Zt(t, n, c, l, i, a);
		for (let e = 0; e < u.length - 2; e++) s.push(u[e]);
	}
	return s;
}
function $t(e, t, n, r, i) {
	let a = [];
	for (let o = 0; o < 24; o++) {
		let s = o / 24 * Math.PI * 2, c = n + (i() - .5) * 2 * r;
		a.push(e + Math.cos(s) * c, t + Math.sin(s) * c);
	}
	return a;
}
function en(e, t, n) {
	let r = e.length / 2;
	if (r < 2) return e;
	let i = [];
	for (let a = 0; a < r; a++) {
		let o = e[a * 2], s = e[a * 2 + 1], c = (a + 1) % r, l = e[c * 2], u = e[c * 2 + 1], d = Zt(o, s, l, u, t, n);
		for (let e = 0; e < d.length - 2; e++) i.push(d[e]);
	}
	return i;
}
//#endregion
//#region src/style/shape/SketchyStyle.ts
function tn(e, t) {
	if (!t) return e;
	let n = t.match(/^rgba\(.+,\s*([\d.]+)\s*\)$/);
	if (!n) return e;
	let r = parseFloat(n[1]);
	return r >= 1 ? e : `rgba(${parseInt(e.slice(1, 3), 16)}, ${parseInt(e.slice(3, 5), 16)}, ${parseInt(e.slice(5, 7), 16)}, ${r})`;
}
function nn(e) {
	let { jitter: t, color: n } = e;
	return { transform(e) {
		switch (e.type) {
			case "rect": {
				let r = B(V(e.x, e.y, e.width, e.height)), i = e.paint.fill ? "#ffffff" : void 0, a = e.paint.stroke ? n : void 0;
				if (e.cornerRadius && e.cornerRadius > 0) {
					let n = [];
					if (i && n.push({
						...e,
						paint: {
							fill: i,
							stroke: void 0,
							strokeWidth: 0
						}
					}), a && e.paint.strokeWidth) {
						let i = {
							type: "polygon",
							vertices: H(e.x, e.y, e.width, e.height, t, r),
							paint: {
								stroke: a,
								strokeWidth: e.paint.strokeWidth
							},
							layer: e.layer,
							hit: e.hit,
							noScale: e.noScale
						};
						n.push(i);
					}
					return n.length === 1 ? n[0] : n;
				}
				return {
					type: "polygon",
					vertices: H(e.x, e.y, e.width, e.height, t, r),
					paint: {
						fill: i,
						stroke: a,
						strokeWidth: e.paint.strokeWidth ?? 0
					},
					layer: e.layer,
					hit: e.hit,
					noScale: e.noScale
				};
			}
			case "circle": {
				let r = B(V(e.cx, e.cy, e.radius));
				return {
					type: "polygon",
					vertices: $t(e.cx, e.cy, e.radius, t, r),
					paint: {
						fill: e.paint.fill ? "#ffffff" : void 0,
						stroke: e.paint.stroke ? n : void 0,
						strokeWidth: e.paint.strokeWidth ?? 0
					},
					layer: e.layer,
					hit: e.hit,
					noScale: e.noScale
				};
			}
			case "line": {
				let r = B(V(...e.points.slice(0, 4))), i = Qt(e.points, t, r), a = tn(n, e.paint.stroke), o = {
					...e.paint,
					stroke: a
				};
				return {
					...e,
					points: i,
					paint: o
				};
			}
			case "polygon": {
				let r = B(V(...e.vertices.slice(0, 4))), i = en(e.vertices, t, r);
				return {
					...e,
					vertices: i,
					paint: {
						...e.paint,
						fill: e.paint.fill ? n : void 0,
						stroke: e.paint.stroke ? n : void 0
					}
				};
			}
			case "text": return {
				...e,
				fill: n
			};
			case "image":
			case "group": return e;
		}
	} };
}
//#endregion
//#region src/style/shape/IsometricStyle.ts
function U(e, t) {
	return F(e, (e) => _(e, t));
}
function W(e, t) {
	if (!t || typeof t == "string") return t;
	if (t.type === "linear") {
		let [n, r] = e(t.x0, t.y0), [i, a] = e(t.x1, t.y1);
		return {
			...t,
			x0: n,
			y0: r,
			x1: i,
			y1: a
		};
	}
	let [n, r] = e(t.cx, t.cy), i = {
		...t,
		cx: n,
		cy: r
	};
	if (t.fx !== void 0 && t.fy !== void 0) {
		let [n, r] = e(t.fx, t.fy);
		i.fx = n, i.fy = r;
	}
	return i;
}
function rn(e) {
	let t = e * Math.PI / 180, n = Math.cos(t), r = Math.sin(t);
	return (e, t) => [e * n - t * r, (e * r + t * n) * .5];
}
function an(e) {
	let t = e * Math.PI / 180, n = Math.cos(t), r = Math.sin(t);
	return (e, t) => [e * n + 2 * t * r, -e * r + 2 * t * n];
}
var G = 32;
function on(e, t) {
	let n = Array(t.length);
	for (let r = 0; r < t.length; r += 2) {
		let [i, a] = e(t[r], t[r + 1]);
		n[r] = i, n[r + 1] = a;
	}
	return n;
}
function sn(e, t, n, r, i) {
	let [a, o] = e(t, n), [s, c] = e(t + r, n), [l, u] = e(t + r, n + i), [d, f] = e(t, n + i);
	return [
		a,
		o,
		s,
		c,
		l,
		u,
		d,
		f
	];
}
function cn(e = {}) {
	let t = e.rotation ?? 0, n = e.depth ?? .18, r = rn(t), i = an(t);
	function a(e, t, n, i) {
		let [a, o] = r(e, t), [s, c] = r(e + n, t), [l, u] = r(e, t + i);
		return [
			(s - a) / n,
			(c - o) / n,
			(l - a) / i,
			(u - o) / i,
			a,
			o
		];
	}
	function o(e) {
		let { x: t, y: i, width: a, height: o, paint: s } = e, c = sn(r, t, i, a, o);
		if (s.dash || s.dashEnabled) {
			let t = [];
			for (let n = 0; n < 8; n += 2) {
				let r = (n + 2) % 8;
				t.push({
					type: "line",
					points: [
						c[n],
						c[n + 1],
						c[r],
						c[r + 1]
					],
					paint: {
						stroke: s.stroke,
						strokeWidth: s.strokeWidth,
						dash: s.dash
					},
					layer: e.layer
				});
			}
			return t;
		}
		if (n > 0 && s.fill) {
			let t = [], i = 0;
			for (let e = 1; e < 4; e++) c[e * 2 + 1] > c[i * 2 + 1] && (i = e);
			let a = c[i * 2], o = c[i * 2 + 1], l = (i + 3) % 4, u = c[l * 2], d = c[l * 2 + 1], f = (i + 1) % 4, p = c[f * 2], m = c[f * 2 + 1], h = (i + 2) % 4, g = c[h * 2], _ = c[h * 2 + 1], v = W(r, s.fill);
			if (t.push({
				type: "polygon",
				vertices: [
					u,
					d,
					a,
					o,
					a,
					o + n,
					u,
					d + n
				],
				paint: { fill: U(v, .2) },
				layer: e.layer
			}), t.push({
				type: "polygon",
				vertices: [
					a,
					o,
					p,
					m,
					p,
					m + n,
					a,
					o + n
				],
				paint: { fill: U(v, .4) },
				layer: e.layer
			}), t.push({
				type: "polygon",
				vertices: c,
				paint: { fill: v },
				layer: e.layer,
				hit: e.hit
			}), s.stroke && s.strokeWidth) {
				let r = s.strokeWidth, i = s.stroke, c = e.layer, l = (e) => t.push({
					type: "line",
					points: e,
					paint: {
						stroke: i,
						strokeWidth: r
					},
					layer: c
				});
				l([
					g,
					_,
					u,
					d
				]), l([
					p,
					m,
					g,
					_
				]), l([
					u,
					d,
					u,
					d + n
				]), l([
					p,
					m,
					p,
					m + n
				]), l([
					u,
					d + n,
					a,
					o + n
				]), l([
					a,
					o + n,
					p,
					m + n
				]);
			}
			return t;
		}
		return {
			type: "polygon",
			vertices: c,
			paint: {
				fill: W(r, s.fill),
				stroke: s.stroke,
				strokeWidth: s.strokeWidth
			},
			layer: e.layer,
			hit: e.hit,
			noScale: e.noScale
		};
	}
	function s(e) {
		let { cx: t, cy: i, radius: a, paint: o } = e, s = Array(G * 2);
		for (let e = 0; e < G; e++) {
			let n = e / G * Math.PI * 2, [o, c] = r(t + Math.cos(n) * a, i + Math.sin(n) * a);
			s[e * 2] = o, s[e * 2 + 1] = c;
		}
		if (o.dash || o.dashEnabled) {
			let t = [];
			for (let n = 0; n < G; n++) {
				let r = (n + 1) % G;
				t.push({
					type: "line",
					points: [
						s[n * 2],
						s[n * 2 + 1],
						s[r * 2],
						s[r * 2 + 1]
					],
					paint: {
						stroke: o.stroke,
						strokeWidth: o.strokeWidth,
						dash: o.dash
					},
					layer: e.layer
				});
			}
			return t;
		}
		let c = [], l = W(r, o.fill);
		if (n > 0 && o.fill) {
			let t = 0, r = 0, i = 0, a = -Infinity, u = Infinity, d = -Infinity;
			for (let e = 0; e < G; e++) s[e * 2] > a && (a = s[e * 2], t = e), s[e * 2] < u && (u = s[e * 2], r = e), s[e * 2 + 1] > d && (d = s[e * 2 + 1], i = e);
			let f = [], p = t;
			for (let e = 0; e <= G && (f.push(s[p * 2], s[p * 2 + 1]), p !== i); e++) p = (p + 1) % G;
			for (let e = f.length - 2; e >= 0; e -= 2) f.push(f[e], f[e + 1] + n);
			c.push({
				type: "polygon",
				vertices: f,
				paint: {
					fill: U(l, .2),
					stroke: o.stroke,
					strokeWidth: o.strokeWidth ? o.strokeWidth * .5 : void 0
				},
				layer: e.layer
			});
			let m = [];
			p = i;
			for (let e = 0; e <= G && (m.push(s[p * 2], s[p * 2 + 1]), p !== r); e++) p = (p + 1) % G;
			for (let e = m.length - 2; e >= 0; e -= 2) m.push(m[e], m[e + 1] + n);
			c.push({
				type: "polygon",
				vertices: m,
				paint: {
					fill: U(l, .4),
					stroke: o.stroke,
					strokeWidth: o.strokeWidth ? o.strokeWidth * .5 : void 0
				},
				layer: e.layer
			});
		}
		let u = {
			type: "polygon",
			vertices: s,
			paint: {
				fill: l,
				stroke: o.stroke,
				strokeWidth: o.strokeWidth
			},
			layer: e.layer,
			hit: e.hit,
			noScale: e.noScale
		};
		return c.push(u), c.length === 1 ? c[0] : c;
	}
	return {
		transform(e) {
			switch (e.type) {
				case "rect": return o(e);
				case "circle": return s(e);
				case "line": return {
					...e,
					points: on(r, e.points)
				};
				case "polygon": return {
					...e,
					vertices: on(r, e.vertices),
					paint: {
						...e.paint,
						fill: W(r, e.paint.fill)
					}
				};
				case "text": {
					let t = e.width ?? 0, n = e.height ?? 0;
					if (t > 0 && n > 0) return {
						...e,
						x: 0,
						y: 0,
						transform: a(e.x, e.y, t, n)
					};
					let [i, o] = r(e.x, e.y);
					return {
						...e,
						x: i,
						y: o
					};
				}
				case "image": return {
					...e,
					x: 0,
					y: 0,
					transform: a(e.x, e.y, e.width, e.height)
				};
				case "group": {
					let [t, i] = r(e.x, e.y);
					return n > 0 && e.layer === "link" ? {
						...e,
						x: t,
						y: i + n
					} : {
						...e,
						x: t,
						y: i
					};
				}
			}
		},
		worldToScene(e, t) {
			let [n, i] = r(e, t);
			return {
				x: n,
				y: i
			};
		},
		sceneToWorld(e, t) {
			let [n, r] = i(e, t);
			return {
				x: n,
				y: r
			};
		},
		sceneLayerOffset(e) {
			return n > 0 && e === "link" ? {
				x: 0,
				y: n
			} : {
				x: 0,
				y: 0
			};
		}
	};
}
//#endregion
//#region src/style/shape/ConstructionStyle.ts
var K = "#1a1a1a", ln = "#ffc200", un = "#ff6600", dn = 26, fn = 26, pn = 26, mn = 255, hn = 194, gn = 0;
function _n(e) {
	let t = I(e);
	if (!t) return L(mn, hn, gn);
	let n = R(t);
	return L(Math.round(dn + (mn - dn) * n), Math.round(fn + (hn - fn) * n), Math.round(pn + (gn - pn) * n), t.a);
}
function vn(e) {
	return {
		...e,
		fill: F(e.fill, _n),
		stroke: e.stroke ? K : e.stroke
	};
}
function yn(e, t, n, r) {
	let i = [], a = e.length;
	for (let o = 0; o < a; o++) {
		let s = e[o], c = e[(o + 1) % a], l = t * s[0] + n * s[1] - r, u = t * c[0] + n * c[1] - r;
		if (l >= 0 && i.push(s), l > 0 && u < 0 || l < 0 && u > 0) {
			let e = l / (l - u);
			i.push([s[0] + e * (c[0] - s[0]), s[1] + e * (c[1] - s[1])]);
		}
	}
	return i;
}
function bn(e, t, n, r, i) {
	let a = [
		[e, t],
		[e + n, t],
		[e + n, t + r],
		[e, t + r]
	], o = i * .4, s = o * .35, c = e + t, l = e + n + t + r, u = Math.floor(c / o) - 1, d = Math.ceil(l / o) + 1, f = [];
	for (let e = u; e <= d; e++) {
		let t = e * o, n = t + s, r = yn(a, 1, 1, t);
		r = yn(r, -1, -1, -n), r.length >= 3 && f.push(r.flatMap((e) => [e[0], e[1]]));
	}
	return f;
}
var xn = { transform(e, t) {
	switch (e.type) {
		case "rect": {
			if (!e.paint.fill) return {
				...e,
				paint: vn(e.paint)
			};
			let n = {
				...e,
				paint: {
					fill: K,
					strokeWidth: e.paint.strokeWidth
				}
			}, r = bn(e.x, e.y, e.width, e.height, t.roomSize).map((t) => ({
				type: "polygon",
				vertices: t,
				layer: e.layer,
				paint: {
					fill: ln,
					alpha: .65
				}
			})), i = {
				...e,
				hit: void 0,
				paint: {
					stroke: K,
					strokeWidth: e.paint.strokeWidth
				}
			};
			return [
				n,
				...r,
				i
			];
		}
		case "circle": return {
			...e,
			paint: vn(e.paint)
		};
		case "polygon": return {
			...e,
			paint: {
				...e.paint,
				fill: e.paint.fill ? un : e.paint.fill,
				stroke: e.paint.stroke ? K : e.paint.stroke
			}
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: un
			} : e.paint
		};
		case "text": return {
			...e,
			fill: un,
			stroke: K,
			strokeWidth: t.roomSize * .25
		};
		case "image":
		case "group": return e;
	}
} }, Sn = "#c8eeff", Cn = "#00c8ff", wn = "#00ffaa", Tn = .2, En = 5, q = 190;
function Dn(e, t, n) {
	e /= 255, t /= 255, n /= 255;
	let r = Math.max(e, t, n), i = Math.min(e, t, n), a = (r + i) / 2;
	if (r === i) return [
		q,
		0,
		a
	];
	let o = r - i, s = a > .5 ? o / (2 - r - i) : o / (r + i), c;
	return c = r === e ? ((t - n) / o + (t < n ? 6 : 0)) / 6 : r === t ? ((n - e) / o + 2) / 6 : ((e - t) / o + 4) / 6, [
		c * 360,
		s,
		a
	];
}
function On(e, t, n, r = 1) {
	e = (e % 360 + 360) % 360;
	let i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(e / 60 % 2 - 1)), o = n - i / 2, s, c, l;
	e < 60 ? (s = i, c = a, l = 0) : e < 120 ? (s = a, c = i, l = 0) : e < 180 ? (s = 0, c = i, l = a) : e < 240 ? (s = 0, c = a, l = i) : e < 300 ? (s = a, c = 0, l = i) : (s = i, c = 0, l = a);
	let u = Math.round((s + o) * 255), d = Math.round((c + o) * 255), f = Math.round((l + o) * 255);
	return r < 1 ? `rgba(${u},${d},${f},${r})` : `rgb(${u},${d},${f})`;
}
function kn(e) {
	let t = I(e);
	if (!t) return On(q, .55, .18);
	let [n, r] = Dn(t.r, t.g, t.b);
	return On(r < .08 ? q : n, .55, .18, t.a);
}
function An(e) {
	return {
		...e,
		fill: F(e.fill, kn),
		stroke: e.stroke ? Cn : e.stroke
	};
}
function jn(e) {
	return {
		stroke: Cn,
		strokeWidth: (e.strokeWidth ?? 1) * En,
		alpha: Tn
	};
}
function Mn(e) {
	return {
		stroke: wn,
		strokeWidth: (e.strokeWidth ?? 1) * En,
		alpha: Tn,
		dash: e.dash,
		dashEnabled: e.dashEnabled
	};
}
var Nn = { transform(e) {
	switch (e.type) {
		case "rect": {
			let t = {
				...e,
				paint: An(e.paint)
			};
			return e.paint.stroke ? [{
				...e,
				hit: void 0,
				paint: {
					...jn(e.paint),
					fill: void 0
				}
			}, t] : t;
		}
		case "circle": {
			let t = {
				...e,
				paint: An(e.paint)
			};
			return e.paint.stroke ? [{
				...e,
				hit: void 0,
				paint: {
					...jn(e.paint),
					fill: void 0
				}
			}, t] : t;
		}
		case "line": {
			if (e.grid) return {
				...e,
				paint: e.paint.stroke ? {
					...e.paint,
					stroke: "#0a1e2e"
				} : e.paint
			};
			let t = {
				...e,
				paint: e.paint.stroke ? {
					...e.paint,
					stroke: wn
				} : e.paint
			};
			return e.paint.stroke ? [{
				...e,
				hit: void 0,
				paint: Mn(e.paint)
			}, t] : t;
		}
		case "polygon": return {
			...e,
			paint: {
				...e.paint,
				fill: e.paint.fill ? wn : e.paint.fill,
				stroke: void 0
			}
		};
		case "text": return {
			...e,
			fill: Sn
		};
		case "image":
		case "group": return e;
	}
} }, Pn = {
	lighten: .35,
	darken: .25
};
function Fn(e = {}) {
	let t = e.lighten ?? Pn.lighten, n = e.darken ?? Pn.darken;
	function r(e, r, i, a, s) {
		let c = e.fill;
		if (typeof c != "string") return e;
		let l = {
			type: "linear",
			x0: r,
			y0: i,
			x1: r,
			y1: i + s,
			stops: [{
				offset: 0,
				color: o(c, t)
			}, {
				offset: 1,
				color: _(c, n)
			}]
		};
		return {
			...e,
			fill: l
		};
	}
	return { transform(e) {
		switch (e.type) {
			case "rect": return {
				...e,
				paint: r(e.paint, e.x, e.y, e.width, e.height)
			};
			case "circle": return {
				...e,
				paint: r(e.paint, e.cx - e.radius, e.cy - e.radius, e.radius * 2, e.radius * 2)
			};
			case "polygon": {
				if (typeof e.paint.fill != "string") return e;
				let t = Infinity, n = -Infinity, i = Infinity;
				for (let r = 0; r < e.vertices.length; r += 2) {
					let a = e.vertices[r], o = e.vertices[r + 1];
					o < t && (t = o), o > n && (n = o), a < i && (i = a);
				}
				return {
					...e,
					paint: r(e.paint, i, t, 1, n - t)
				};
			}
			default: return e;
		}
	} };
}
//#endregion
//#region src/style/shape/StainedGlassStyle.ts
var In = "#0a0a0a", Ln = "#f4f0e0", Rn = .6, zn = .4, Bn = .62, Vn = 2.2, Hn = .06;
function Un(e) {
	let t = I(e);
	if (!t) return e;
	let [n, r, i] = mt(t.r, t.g, t.b);
	return ht(n, r < .08 ? r : Math.max(r, Rn), Math.min(Bn, Math.max(zn, i)), t.a);
}
function Wn(e) {
	return Math.max((e ?? .04) * Vn, Hn);
}
function Gn(e) {
	let t = F(e.fill, Un), n = t !== void 0 || e.stroke !== void 0;
	return {
		...e,
		fill: t,
		stroke: n ? In : void 0,
		strokeWidth: n ? Wn(e.strokeWidth) : e.strokeWidth,
		dash: void 0,
		dashEnabled: void 0
	};
}
var Kn = { transform(e) {
	switch (e.type) {
		case "rect":
		case "circle":
		case "polygon": return {
			...e,
			paint: Gn(e.paint)
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: In,
				strokeWidth: Wn(e.paint.strokeWidth)
			} : e.paint
		};
		case "text": return {
			...e,
			fill: Ln
		};
		case "image":
		case "group": return e;
	}
} }, qn = "#1c3f6e", Jn = 1.4, Yn = .05, Xn = 198, Zn = 212, Qn = 230, $n = 248, er = 250, tr = 255;
function nr(e) {
	let t = I(e);
	if (!t) return L($n, er, tr);
	let n = R(t);
	return L(Math.round(Xn + ($n - Xn) * n), Math.round(Zn + (er - Zn) * n), Math.round(Qn + (tr - Qn) * n), t.a);
}
function rr(e) {
	let t = I(e);
	if (!t || t.a >= 1) return qn;
	let n = I(qn);
	return L(n.r, n.g, n.b, t.a);
}
function ir(e) {
	return Math.max((e ?? .04) * Jn, Yn);
}
function ar(e) {
	return {
		...e,
		fill: F(e.fill, nr),
		stroke: e.stroke ? rr(e.stroke) : e.stroke,
		strokeWidth: e.stroke ? ir(e.strokeWidth) : e.strokeWidth
	};
}
var or = { transform(e) {
	switch (e.type) {
		case "rect":
		case "circle":
		case "polygon": return {
			...e,
			paint: ar(e.paint)
		};
		case "line": return e.paint.stroke ? {
			...e,
			paint: {
				...e.paint,
				stroke: rr(e.paint.stroke),
				strokeWidth: e.grid ? e.paint.strokeWidth : ir(e.paint.strokeWidth)
			}
		} : e;
		case "text": return {
			...e,
			fill: qn
		};
		case "image":
		case "group": return e;
	}
} }, sr = "#7a6a48", cr = "#8a7a55", lr = "#4a3f28", ur = 78, dr = 93, fr = 52, pr = 221, mr = 207, hr = 166, gr = 2, _r = .26, vr = .02;
function yr(e) {
	let t = I(e);
	if (!t) return L(pr, mr, hr);
	let n = R(t);
	return L(Math.round(ur + (pr - ur) * n), Math.round(dr + (mr - dr) * n), Math.round(fr + (hr - fr) * n), t.a);
}
function br(e) {
	return {
		...e,
		fill: F(e.fill, yr),
		stroke: e.stroke ? sr : e.stroke
	};
}
var xr = {
	stroke: sr,
	strokeWidth: vr
}, Sr = { transform(e) {
	switch (e.type) {
		case "rect": {
			let t = {
				...e,
				paint: br(e.paint)
			};
			if (!e.paint.fill) return t;
			let n = [t], r = Math.min(e.width, e.height) / 2 * _r, i = Math.min(e.width, e.height) * .12;
			for (let t = 1; t <= gr; t++) {
				let a = r * t, o = e.width - a * 2, s = e.height - a * 2;
				if (o <= i || s <= i) break;
				n.push({
					type: "rect",
					x: e.x + a,
					y: e.y + a,
					width: o,
					height: s,
					cornerRadius: e.cornerRadius,
					paint: xr,
					layer: e.layer,
					noScale: e.noScale
				});
			}
			return n;
		}
		case "circle": {
			let t = {
				...e,
				paint: br(e.paint)
			};
			if (!e.paint.fill) return t;
			let n = [t], r = e.radius * _r;
			for (let t = 1; t <= gr; t++) {
				let i = e.radius - r * t;
				if (i <= e.radius * .12) break;
				n.push({
					type: "circle",
					cx: e.cx,
					cy: e.cy,
					radius: i,
					paint: xr,
					layer: e.layer,
					noScale: e.noScale
				});
			}
			return n;
		}
		case "polygon": {
			let t = {
				...e,
				paint: br(e.paint)
			};
			if (!e.paint.fill) return t;
			let n = [t], r = e.vertices.length / 2, i = 0, a = 0;
			for (let t = 0; t < r; t++) i += e.vertices[t * 2], a += e.vertices[t * 2 + 1];
			i /= r, a /= r;
			for (let t = 1; t <= gr; t++) {
				let o = 1 - _r * t;
				if (o <= .15) break;
				let s = [];
				for (let t = 0; t < r; t++) s.push(i + (e.vertices[t * 2] - i) * o, a + (e.vertices[t * 2 + 1] - a) * o);
				n.push({
					type: "polygon",
					vertices: s,
					paint: xr,
					layer: e.layer,
					noScale: e.noScale
				});
			}
			return n;
		}
		case "line": return e.paint.stroke ? {
			...e,
			paint: {
				...e.paint,
				stroke: cr
			}
		} : e;
		case "text": return {
			...e,
			fill: lr
		};
		case "image":
		case "group": return e;
	}
} }, Cr = "#3a3a44";
function wr(e, t) {
	return F(e, (e) => {
		let n = I(e);
		return n ? `rgba(${n.r}, ${n.g}, ${n.b}, ${(n.a * t).toFixed(3)})` : e;
	});
}
function Tr(e = {}) {
	let t = e.bleed ?? .05, n = Math.max(1, Math.min(4, e.layers ?? 2)), r = e.alpha ?? .4;
	function i(e, t, i, a, o, s) {
		let c = wr(t.fill, r), l = [];
		for (let t = 0; t < n; t++) {
			let n = B(i + t * 2654435769);
			l.push({
				type: "polygon",
				vertices: e(n),
				paint: {
					fill: c,
					strokeWidth: 0
				},
				layer: a,
				hit: t === 0 ? o : void 0,
				noScale: s
			});
		}
		return l;
	}
	return { transform(e) {
		switch (e.type) {
			case "rect":
				if (!e.paint.fill) {
					let n = B(V(e.x, e.y, e.width, e.height));
					return {
						type: "polygon",
						vertices: H(e.x, e.y, e.width, e.height, t, n),
						paint: {
							stroke: e.paint.stroke,
							strokeWidth: e.paint.strokeWidth ?? 0,
							alpha: .5
						},
						layer: e.layer,
						hit: e.hit,
						noScale: e.noScale
					};
				}
				return i((n) => H(e.x, e.y, e.width, e.height, t, n), e.paint, V(e.x, e.y, e.width, e.height), e.layer, e.hit, e.noScale);
			case "circle":
				if (!e.paint.fill) {
					let n = B(V(e.cx, e.cy, e.radius));
					return {
						type: "polygon",
						vertices: $t(e.cx, e.cy, e.radius, t, n),
						paint: {
							stroke: e.paint.stroke,
							strokeWidth: e.paint.strokeWidth ?? 0,
							alpha: .5
						},
						layer: e.layer,
						hit: e.hit,
						noScale: e.noScale
					};
				}
				return i((n) => $t(e.cx, e.cy, e.radius, t, n), e.paint, V(e.cx, e.cy, e.radius), e.layer, e.hit, e.noScale);
			case "polygon":
				if (!e.paint.fill) {
					let n = B(V(...e.vertices.slice(0, 4)));
					return {
						...e,
						vertices: en(e.vertices, t, n),
						paint: {
							...e.paint,
							alpha: .5
						}
					};
				}
				return i((n) => en(e.vertices, t, n), e.paint, V(...e.vertices.slice(0, 4)), e.layer, e.hit, e.noScale);
			case "line": return {
				...e,
				paint: {
					...e.paint,
					alpha: (e.paint.alpha ?? 1) * .6
				}
			};
			case "text": return {
				...e,
				fill: Cr
			};
			case "image":
			case "group": return e;
		}
	} };
}
//#endregion
//#region src/style/shape/DarkModernStyle.ts
var Er = "rgba(255, 255, 255, 0.14)", Dr = "#5b6573", Or = "#e6e8ec", kr = "rgba(0, 0, 0, 0.38)", Ar = .08, jr = .34;
function Mr(e) {
	let t = I(e);
	if (!t) return "rgb(38, 42, 48)";
	let [n, r, i] = mt(t.r, t.g, t.b);
	return ht(n, Math.min(r, jr), .22 + i * .18, t.a);
}
function Nr(e) {
	return {
		...e,
		fill: F(e.fill, Mr),
		stroke: e.stroke ? Er : e.stroke
	};
}
function Pr(e) {
	return e.hit?.kind === "room" && e.paint.fill !== void 0;
}
var Fr = { transform(e, t) {
	switch (e.type) {
		case "rect": {
			let n = {
				...e,
				paint: Nr(e.paint)
			};
			if (!Pr(e)) return n;
			let r = t.roomSize * Ar;
			return [{
				type: "rect",
				x: e.x + r,
				y: e.y + r,
				width: e.width,
				height: e.height,
				cornerRadius: e.cornerRadius,
				paint: { fill: kr },
				layer: e.layer,
				noScale: e.noScale
			}, n];
		}
		case "circle": {
			let n = {
				...e,
				paint: Nr(e.paint)
			};
			if (!Pr(e)) return n;
			let r = t.roomSize * Ar;
			return [{
				type: "circle",
				cx: e.cx + r,
				cy: e.cy + r,
				radius: e.radius,
				paint: { fill: kr },
				layer: e.layer,
				noScale: e.noScale
			}, n];
		}
		case "polygon": return {
			...e,
			paint: Nr(e.paint)
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: Dr
			} : e.paint
		};
		case "text": return {
			...e,
			fill: Or
		};
		case "image":
		case "group": return e;
	}
} }, J = "#5a3a22", Ir = "#43301c", Lr = 120, Rr = 86, zr = 50, Br = 232, Vr = 205, Hr = 158;
function Ur(e) {
	let t = I(e);
	if (!t) return L(Br, Vr, Hr);
	let n = R(t);
	return L(Math.round(Lr + (Br - Lr) * n), Math.round(Rr + (Vr - Rr) * n), Math.round(zr + (Hr - zr) * n), t.a);
}
function Wr(e) {
	let t = I(e);
	if (!t || t.a >= 1) return J;
	let n = I(J);
	return L(n.r, n.g, n.b, t.a);
}
function Gr(e) {
	return {
		...e,
		fill: F(e.fill, Ur),
		stroke: e.stroke ? Wr(e.stroke) : e.stroke
	};
}
var Kr = { transform(e) {
	switch (e.type) {
		case "rect":
		case "circle":
		case "polygon": return {
			...e,
			paint: Gr(e.paint)
		};
		case "line": return {
			...e,
			paint: e.paint.stroke ? {
				...e.paint,
				stroke: Wr(e.paint.stroke)
			} : e.paint
		};
		case "text": return {
			...e,
			fill: Ir
		};
		case "image":
		case "group": return e;
	}
} };
function qr(e, t, n) {
	let r = [], i = n * .42;
	for (let a = 0; a < 8; a++) {
		let o = (-90 + a * 45) * (Math.PI / 180), s = a % 2 == 0 ? n : i;
		r.push(e + s * Math.cos(o), t + s * Math.sin(o));
	}
	return r;
}
function Jr() {
	let e;
	return {
		attach(t) {
			e = t.onViewportChange(() => t.invalidate());
		},
		detach() {
			e?.(), e = void 0;
		},
		render(e, t) {
			let n = t.maxX - t.minX, r = t.maxY - t.minY;
			if (n <= 0 || r <= 0) return [];
			let i = Math.min(n, r), a = i * .05, o = i * .012, s = i * .006, c = [];
			for (let e of [a, a + o]) c.push({
				type: "rect",
				x: t.minX + e,
				y: t.minY + e,
				width: n - e * 2,
				height: r - e * 2,
				paint: {
					stroke: J,
					strokeWidth: s
				},
				layer: "top"
			});
			let l = i * .07, u = t.maxX - a - o - l * 1.4, d = t.minY + a + o + l * 1.6;
			return c.push({
				type: "circle",
				cx: u,
				cy: d,
				radius: l * 1.25,
				paint: {
					stroke: J,
					strokeWidth: s
				},
				layer: "top"
			}), c.push({
				type: "polygon",
				vertices: qr(u, d, l),
				paint: {
					fill: L(Br, Vr, Hr, .85),
					stroke: J,
					strokeWidth: s
				},
				layer: "top"
			}), c.push({
				type: "circle",
				cx: u,
				cy: d,
				radius: l * .16,
				paint: { fill: J },
				layer: "top"
			}), c.push({
				type: "text",
				x: u,
				y: d - l * 1.25 - l * .55,
				text: "N",
				fontSize: l * .5,
				fontStyle: "bold",
				fill: Ir,
				align: "center",
				verticalAlign: "middle",
				layer: "top"
			}), c;
		}
	};
}
//#endregion
//#region src/style/index.ts
var Yr = Dt, Xr = zt, Zr = Xt;
function Qr(e) {
	return nn(e);
}
function $r(e = {}) {
	return cn(e);
}
var ei = xn, ti = Nn;
function ni(e = {}) {
	return Fn(e);
}
var ri = Kn, ii = or, ai = Sr;
function oi(e = {}) {
	return Tr(e);
}
var si = Fr, ci = Kr, li = class {
	get settings() {
		return this.state.settings;
	}
	get camera() {
		return this.backend.camera;
	}
	get culling() {
		return this.backend.culling;
	}
	get hitTester() {
		return this.backend.hitTester;
	}
	get events() {
		return this.backend.events;
	}
	constructor(e, t, n, r) {
		this.currentStyle = x, this.state = new Me(e, t ?? je()), this.backend = r ? r(this.state) : new pt(this.state, n);
	}
	destroy() {
		this.backend.destroy();
	}
	drawArea(e, t) {
		this.state.setArea(e, t);
	}
	getCurrentArea() {
		return this.state.currentAreaInstance;
	}
	setPosition(e, t = !0) {
		this.state.setPosition(e, t);
	}
	updatePositionMarker(e) {
		this.state.updatePositionMarker(e);
	}
	clearPosition() {
		this.state.clearPosition();
	}
	centerOn(e, t) {
		this.state.setCenterRoom(e, t);
	}
	renderHighlight(e, t) {
		this.state.addHighlight(e, t);
	}
	removeHighlight(e) {
		this.state.removeHighlight(e);
	}
	hasHighlight(e) {
		return this.state.hasHighlight(e);
	}
	clearHighlights() {
		this.state.clearHighlights();
	}
	renderPath(e, t) {
		this.state.addPath(e, t);
	}
	clearPaths() {
		this.state.clearPaths();
	}
	refreshCurrentRoomOverlay() {
		this.state.refreshPosition();
	}
	setLens(e) {
		this.state.setLens(e);
	}
	getLens() {
		return this.state.lens;
	}
	setStyle(e) {
		this.currentStyle = e, this.backend.setStyle(e);
	}
	clearStyle() {
		this.setStyle(x);
	}
	getStyle() {
		return this.currentStyle;
	}
	updateBackground() {
		this.backend.updateBackground();
	}
	refresh() {
		this.backend.updateBackground(), this.backend.refresh();
	}
	addSceneOverlay(e, t) {
		this.backend.addSceneOverlay(e, t);
	}
	removeSceneOverlay(e) {
		this.backend.removeSceneOverlay(e);
	}
	addLiveEffect(e, t) {
		this.backend.addLiveEffect?.(e, t);
	}
	removeLiveEffect(e) {
		this.backend.removeLiveEffect?.(e);
	}
	hitTest(e, t) {
		let n = this.backend.coordinateTransform(e, t);
		return this.backend.hitTester.pick(n.x, n.y);
	}
	getDrawnExits() {
		return this.backend.getDrawnExits();
	}
	getDrawnSpecialExits() {
		return this.backend.getDrawnSpecialExits();
	}
	getDrawnStubs() {
		return this.backend.getDrawnStubs();
	}
	export(e) {
		let t = {
			state: this.state,
			backend: this.backend,
			style: this.currentStyle,
			sceneOverlays: this.backend.getSceneOverlays()
		};
		return e.render(t);
	}
	on(e, t) {
		this.backend.events.on(e, t);
	}
	off(e, t) {
		this.backend.events.off(e, t);
	}
	setZoom(e) {
		return this.backend.camera.setZoom(e);
	}
	zoomToCenter(e) {
		return this.backend.camera.zoomToCenter(e);
	}
	getZoom() {
		return this.backend.camera.zoom;
	}
	getViewportBounds() {
		return this.backend.camera.getViewportBounds();
	}
	getAreaBounds() {
		if (!this.state.currentAreaInstance || this.state.currentZIndex === void 0) return null;
		let e = this.state.currentAreaInstance.getPlane(this.state.currentZIndex);
		if (!e) return null;
		let t = this.state.getEffectiveBounds(this.state.currentAreaInstance, e), n = this.state.settings.areaName ? this.state.currentAreaInstance.getAreaName() : null, r = n ? t.minX - 3.5 + n.length * 2.5 * .6 : t.maxX, i = {
			minX: n ? t.minX - 3.5 : t.minX,
			maxX: Math.max(t.maxX, r),
			minY: n ? t.minY - 7 : t.minY,
			maxY: t.maxY
		}, a = this.backend.coordinateTransform, o = a(i.minX, i.minY), s = a(i.maxX, i.minY), c = a(i.maxX, i.maxY), l = a(i.minX, i.maxY);
		return {
			minX: Math.min(o.x, s.x, c.x, l.x),
			maxX: Math.max(o.x, s.x, c.x, l.x),
			minY: Math.min(o.y, s.y, c.y, l.y),
			maxY: Math.max(o.y, s.y, c.y, l.y)
		};
	}
	fitArea(e) {
		let t = this.getAreaBounds();
		t && this.backend.camera.fitToMapBounds(t.minX, t.maxX, t.minY, t.maxY, e);
	}
	get centerOnResize() {
		return this.backend.camera.centerOnResize;
	}
	set centerOnResize(e) {
		this.backend.camera.centerOnResize = e;
	}
	get minZoom() {
		return this.backend.camera.minZoom;
	}
	set minZoom(e) {
		this.backend.camera.minZoom = e;
	}
	setCullingMode(e) {
		this.state.settings.cullingMode = e, this.state.settings.cullingEnabled = e !== "none", this.backend.culling.scheduleCulling();
	}
	getCullingMode() {
		return this.state.settings.cullingMode;
	}
}, ui = "room";
function di(e, t) {
	let n = /* @__PURE__ */ new Map();
	function r(e) {
		let t = n.get(e);
		return t || (t = [], n.set(e, t)), t;
	}
	function i(e, t, n, i, o, s, c) {
		let l = e.layer ?? c ?? ui;
		switch (e.type) {
			case "rect": {
				let a = {
					type: "rect",
					x: (t + e.x) * i + o,
					y: (n + e.y) * i + s,
					w: e.width * i,
					h: e.height * i,
					fill: M(e.paint.fill, t, n, i, o, s),
					stroke: e.paint.stroke,
					sw: (e.paint.strokeWidth ?? 0) * i,
					cr: (e.cornerRadius ?? 0) * i,
					dash: pi(e.paint.dash, i, e.paint.dashEnabled)
				};
				r(l).push(a);
				return;
			}
			case "circle":
				r(l).push({
					type: "circle",
					cx: (t + e.cx) * i + o,
					cy: (n + e.cy) * i + s,
					r: e.radius * i,
					fill: M(e.paint.fill, t, n, i, o, s),
					stroke: e.paint.stroke,
					sw: (e.paint.strokeWidth ?? 0) * i,
					dash: pi(e.paint.dash, i, e.paint.dashEnabled)
				});
				return;
			case "line": {
				let a = {
					type: "line",
					points: fi(e.points, t, n, i, o, s),
					stroke: e.paint.stroke,
					sw: (e.paint.strokeWidth ?? 0) * i,
					dash: pi(e.paint.dash, i, e.paint.dashEnabled),
					lineCap: e.lineCap,
					lineJoin: e.lineJoin,
					alpha: e.paint.alpha
				};
				r(l).push(a);
				return;
			}
			case "polygon": {
				let a = {
					type: "polygon",
					vertices: fi(e.vertices, t, n, i, o, s),
					fill: M(e.paint.fill, t, n, i, o, s),
					stroke: e.paint.stroke,
					sw: (e.paint.strokeWidth ?? 0) * i
				};
				r(l).push(a);
				return;
			}
			case "text": {
				let a = mi(e.transform, t, n, i, o, s), c = {
					type: "text",
					x: a ? 0 : (t + e.x) * i + o,
					y: a ? 0 : (n + e.y) * i + s,
					text: e.text,
					fontSize: e.fontSize * i,
					fontFamily: e.fontFamily ?? "sans-serif",
					fontStyle: e.fontStyle ?? "normal",
					fill: e.fill ?? "black",
					stroke: e.stroke,
					sw: (e.strokeWidth ?? 0) * i,
					align: e.align ?? "left",
					vAlign: e.verticalAlign ?? "top",
					w: (e.width ?? 0) * i,
					h: (e.height ?? 0) * i,
					baselineRatio: e.baselineRatio,
					konvaCorrectionRatio: e.konvaCorrectionRatio,
					transform: a
				};
				r(l).push(c);
				return;
			}
			case "image": {
				let a = mi(e.transform, t, n, i, o, s), c = a ? 0 : (t + e.x) * i + o, u = a ? 0 : (n + e.y) * i + s;
				r(l).push({
					type: "image",
					x: c,
					y: u,
					w: e.width * i,
					h: e.height * i,
					src: e.src,
					transform: a
				});
				return;
			}
			case "group":
				a(e, t, n, i, o, s, l);
				return;
		}
	}
	function a(e, t, n, a, o, s, c) {
		let l = e.layer ?? c;
		if (e.noScale) {
			let c = (t + e.x) * a + o, u = (n + e.y) * a + s, d = r(l ?? ui);
			d.push({
				type: "pushTransform",
				matrix: [
					1,
					0,
					0,
					1,
					c,
					u
				]
			});
			for (let t of e.children) i(t, 0, 0, 1, 0, 0, l);
			d.push({ type: "popTransform" });
			return;
		}
		let u = t + e.x, d = n + e.y;
		for (let t of e.children) i(t, u, d, a, o, s, l);
	}
	for (let n of e) i(n, 0, 0, t.scale, t.offsetX, t.offsetY, void 0);
	let o = [];
	for (let [e, t] of n) o.push({
		layer: e,
		commands: t
	});
	return o;
}
function fi(e, t, n, r, i, a) {
	let o = Array(e.length);
	for (let s = 0; s < e.length; s += 2) o[s] = (t + e[s]) * r + i, o[s + 1] = (n + e[s + 1]) * r + a;
	return o;
}
function pi(e, t, n) {
	if (n === !1) return;
	if (!e || e.length === 0) return e;
	let r = Array(e.length);
	for (let n = 0; n < e.length; n++) r[n] = e[n] * t;
	return r;
}
function mi(e, t, n, r, i, a) {
	if (!e) return;
	let [o, s, c, l, u, d] = e;
	return [
		o * r,
		s * r,
		c * r,
		l * r,
		u * r + t * r + i,
		d * r + n * r + a
	];
}
//#endregion
//#region src/render/SvgRenderer.ts
function Y(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
function X(e, t) {
	return t === void 0 ? "" : ` ${e}="${typeof t == "string" ? Y(t) : t}"`;
}
function hi(e) {
	return !e || e.length === 0 ? "" : ` stroke-dasharray="${e.join(" ")}"`;
}
var gi = 0;
function _i() {
	return `mmr-grad-${++gi}`;
}
function vi(e, t) {
	let n = t.stops.map((e) => `<stop offset="${e.offset}" stop-color="${Y(e.color)}"/>`).join("");
	return `<defs><linearGradient id="${e}" gradientUnits="userSpaceOnUse" x1="${t.x0}" y1="${t.y0}" x2="${t.x1}" y2="${t.y1}">${n}</linearGradient></defs>`;
}
function yi(e, t) {
	let n = t.stops.map((e) => `<stop offset="${e.offset}" stop-color="${Y(e.color)}"/>`).join(""), r = (t.fx === void 0 ? "" : ` fx="${t.fx}"`) + (t.fy === void 0 ? "" : ` fy="${t.fy}"`) + (t.fr === void 0 ? "" : ` fr="${t.fr}"`);
	return `<defs><radialGradient id="${e}" gradientUnits="userSpaceOnUse" cx="${t.cx}" cy="${t.cy}" r="${t.r}"${r}>${n}</radialGradient></defs>`;
}
function bi(e, t) {
	if (e === void 0) return;
	if (typeof e == "string") return e;
	let n = _i();
	return t.push(e.type === "linear" ? vi(n, e) : yi(n, e)), `url(#${n})`;
}
function xi(e) {
	let t = [];
	for (let n of e) Si(n.commands, t);
	return t;
}
function Si(e, t) {
	let n = [];
	for (let r of e) switch (r.type) {
		case "pushTransform": {
			let [e, i, a, o, s, c] = r.matrix;
			t.push(`<g transform="matrix(${e},${i},${a},${o},${s},${c})">`), n.push("</g>");
			break;
		}
		case "pushClip":
			t.push("<g>"), n.push("</g>");
			break;
		case "popTransform":
		case "popClip": {
			let e = n.pop();
			e && t.push(e);
			break;
		}
		default:
			Ci(r, t);
			break;
	}
	for (; n.length > 0;) t.push(n.pop());
}
function Ci(e, t) {
	switch (e.type) {
		case "rect": {
			let n = bi(e.fill, t) ?? "none", r = e.cr > 0 ? `${X("rx", e.cr)}${X("ry", e.cr)}` : "";
			t.push(`<rect${X("x", e.x)}${X("y", e.y)}${X("width", e.w)}${X("height", e.h)}${X("fill", n)}${X("stroke", e.stroke)}${e.sw ? X("stroke-width", e.sw) : ""}${r}${hi(e.dash)}/>`);
			return;
		}
		case "circle": {
			let n = bi(e.fill, t) ?? "none";
			t.push(`<circle${X("cx", e.cx)}${X("cy", e.cy)}${X("r", e.r)}${X("fill", n)}${X("stroke", e.stroke)}${e.sw ? X("stroke-width", e.sw) : ""}${hi(e.dash)}/>`);
			return;
		}
		case "line": {
			let n = e.points;
			if (n.length < 2) return;
			let r = [];
			for (let e = 0; e < n.length; e += 2) r.push(`${n[e]},${n[e + 1]}`);
			t.push(`<polyline points="${r.join(" ")}"${X("stroke", e.stroke)}${e.sw ? X("stroke-width", e.sw) : ""}${hi(e.dash)}${X("stroke-linecap", e.lineCap)}${X("stroke-linejoin", e.lineJoin)}${X("opacity", e.alpha)} fill="none"/>`);
			return;
		}
		case "polygon": {
			let n = e.vertices;
			if (n.length < 4) return;
			let r = [];
			for (let e = 0; e < n.length; e += 2) r.push(`${n[e]},${n[e + 1]}`);
			let i = bi(e.fill, t);
			t.push(`<polygon points="${r.join(" ")}"${X("fill", i)}${X("stroke", e.stroke)}${e.sw ? X("stroke-width", e.sw) : ""}/>`);
			return;
		}
		case "text": {
			let n = e.x, r = e.y, i = "start", a = "auto";
			e.w > 0 && (e.align === "center" ? (n = e.x + e.w / 2, i = "middle") : e.align === "right" && (n = e.x + e.w, i = "end")), e.h > 0 && e.vAlign === "middle" && (e.baselineRatio === void 0 ? (r = e.y + e.h / 2, a = "central") : r = e.y + e.h / 2 + e.baselineRatio * e.fontSize);
			let o = e.transform ? ` transform="matrix(${e.transform.join(",")})"` : "", s = e.fontStyle === "bold" ? " font-weight=\"bold\"" : "", c = e.stroke && e.sw > 0 ? ` stroke="${e.stroke}" stroke-width="${e.sw}" paint-order="stroke fill"` : "";
			t.push(`<text${X("x", n)}${X("y", r)}${X("font-size", e.fontSize)}${e.fontFamily ? X("font-family", e.fontFamily) : ""}${s}${X("fill", e.fill)}${c} text-anchor="${i}" dominant-baseline="${a}"${o}>${Y(e.text)}</text>`);
			return;
		}
		case "image":
			if (e.transform) {
				let [n, r, i, a, o, s] = e.transform;
				t.push(`<image${X("width", e.w)}${X("height", e.h)} href="${Y(e.src)}" transform="matrix(${n},${r},${i},${a},${o},${s})"/>`);
				return;
			}
			t.push(`<image${X("x", e.x)}${X("y", e.y)}${X("width", e.w)}${X("height", e.h)} href="${Y(e.src)}"/>`);
			return;
	}
}
//#endregion
//#region src/render/CanvasRenderer.ts
var wi = (e) => {
	if (typeof Image < "u") {
		let t = new Image();
		return t.src = e, t;
	}
	return null;
};
function Ti(e, t, n = {}) {
	let r = n.imageFactory ?? wi;
	for (let n of t) Ei(e, n.commands, r);
}
function Ei(e, t, n) {
	let r = 0;
	for (let i of t) switch (i.type) {
		case "pushTransform":
			e.save(), r++, e.transform(...i.matrix);
			break;
		case "pushClip":
			e.save(), r++, e.beginPath(), e.rect(i.x, i.y, i.w, i.h), e.clip();
			break;
		case "popTransform":
		case "popClip":
			r > 0 && (e.restore(), r--);
			break;
		default:
			Di(e, i, n);
			break;
	}
	for (; r > 0;) e.restore(), r--;
}
function Di(e, t, n) {
	switch (t.type) {
		case "rect":
			e.beginPath(), t.cr > 0 && typeof e.roundRect == "function" ? e.roundRect(t.x, t.y, t.w, t.h, t.cr) : e.rect(t.x, t.y, t.w, t.h), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, e.setLineDash(t.dash ?? []), e.stroke());
			break;
		case "circle":
			e.beginPath(), e.arc(t.cx, t.cy, t.r, 0, Math.PI * 2), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, e.setLineDash(t.dash ?? []), e.stroke());
			break;
		case "line": {
			if (t.points.length < 4) break;
			let n = e.globalAlpha;
			t.alpha !== void 0 && (e.globalAlpha = t.alpha), e.beginPath(), e.moveTo(t.points[0], t.points[1]);
			for (let n = 2; n < t.points.length; n += 2) e.lineTo(t.points[n], t.points[n + 1]);
			t.stroke && (e.strokeStyle = t.stroke), e.lineWidth = t.sw, e.setLineDash(t.dash ?? []), t.lineCap && (e.lineCap = t.lineCap), t.lineJoin && (e.lineJoin = t.lineJoin), e.stroke(), t.alpha !== void 0 && (e.globalAlpha = n);
			break;
		}
		case "polygon":
			if (t.vertices.length < 4) break;
			e.beginPath(), e.moveTo(t.vertices[0], t.vertices[1]);
			for (let n = 2; n < t.vertices.length; n += 2) e.lineTo(t.vertices[n], t.vertices[n + 1]);
			e.closePath(), t.fill && (e.fillStyle = k(e, t.fill), e.fill()), t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw, e.setLineDash([]), e.stroke());
			break;
		case "text": {
			let n = t.fontSize * 100, r = `${t.fontStyle} ${n}px ${t.fontFamily}`;
			e.save(), e.font = r, e.fillStyle = t.fill, t.stroke && t.sw > 0 && (e.strokeStyle = t.stroke, e.lineWidth = t.sw * 100, e.lineJoin = "round");
			let i = t.baselineRatio !== void 0;
			if (t.transform) if (e.transform(...t.transform), e.scale(1 / 100, 1 / 100), e.textAlign = "center", i) {
				e.textBaseline = "alphabetic";
				let n = (t.h / 2 + t.baselineRatio * t.fontSize) * 100;
				t.stroke && t.sw > 0 && e.strokeText(t.text, t.w * 100 / 2, n), e.fillText(t.text, t.w * 100 / 2, n);
			} else {
				e.textBaseline = "middle";
				let n = t.w * 100 / 2, r = t.h * 100 / 2;
				t.stroke && t.sw > 0 && e.strokeText(t.text, n, r), e.fillText(t.text, n, r);
			}
			else if (t.w > 0 && t.h > 0) {
				e.textAlign = t.align || "left";
				let n = t.align === "center" ? t.x + t.w / 2 : t.align === "right" ? t.x + t.w : t.x;
				if (e.scale(1 / 100, 1 / 100), t.vAlign === "middle" && i) {
					e.textBaseline = "alphabetic";
					let r = t.y + t.h / 2 + t.baselineRatio * t.fontSize;
					t.stroke && t.sw > 0 && e.strokeText(t.text, n * 100, r * 100), e.fillText(t.text, n * 100, r * 100);
				} else {
					e.textBaseline = t.vAlign === "middle" ? "middle" : "top";
					let r = t.vAlign === "middle" ? t.y + t.h / 2 : t.y;
					t.stroke && t.sw > 0 && e.strokeText(t.text, n * 100, r * 100), e.fillText(t.text, n * 100, r * 100);
				}
			} else e.textAlign = "left", e.textBaseline = "top", e.scale(1 / 100, 1 / 100), t.stroke && t.sw > 0 && e.strokeText(t.text, t.x * 100, t.y * 100), e.fillText(t.text, t.x * 100, t.y * 100);
			e.restore();
			break;
		}
		case "image": {
			let r = n(t.src);
			if (!r) break;
			t.transform ? (e.save(), e.transform(...t.transform), e.drawImage(r, 0, 0, t.w, t.h), e.restore()) : e.drawImage(r, t.x, t.y, t.w, t.h);
			break;
		}
	}
}
//#endregion
//#region src/export/sceneBounds.ts
function Oi(e, t, n = 0) {
	if (!t.worldToScene) return e;
	let r = [
		t.worldToScene(e.x, e.y),
		t.worldToScene(e.x + e.w, e.y),
		t.worldToScene(e.x, e.y + e.h),
		t.worldToScene(e.x + e.w, e.y + e.h)
	], i = Infinity, a = -Infinity, o = Infinity, s = -Infinity;
	for (let e of r) e.x < i && (i = e.x), e.x > a && (a = e.x), e.y < o && (o = e.y), e.y > s && (s = e.y);
	return {
		x: i - n,
		y: o - n,
		w: a - i + n * 2,
		h: s - o + n * 2
	};
}
//#endregion
//#region src/export/exportViewport.ts
function ki(e, t) {
	if (!N(e)) return () => {};
	let n = e.getViewport();
	return e.setViewport({
		minX: t.x,
		maxX: t.x + t.w,
		minY: t.y,
		maxY: t.y + t.h
	}), () => e.setViewport(n);
}
//#endregion
//#region src/export/SvgExporter.ts
var Ai = {
	scale: 1,
	offsetX: 0,
	offsetY: 0
};
function ji(e) {
	return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
var Mi = class {
	constructor(e = {}) {
		this.options = e;
	}
	render({ state: e, style: t, sceneOverlays: n }) {
		let { currentArea: r, currentZIndex: i, currentAreaInstance: a } = e;
		if (r === void 0 || i === void 0 || !a) return;
		let o = a, s = o.getPlane(i);
		if (!s) return;
		let c = e.settings, l = this.options.padding ?? 3, u = e.computeExportBounds(o, s, this.options.roomId, l), d = T.forMapBounds(u.x, u.x + u.w, u.y, u.y + u.h).getViewportBounds(), f = ki(e.mapReader, u);
		try {
			let r = Ie(new w(e.mapReader, c).buildScene(o, s, i, e.lens), d, c, {
				forward: t.worldToScene ? (e, n) => t.worldToScene(e, n) : void 0,
				inverse: t.sceneToWorld ? (e, n) => t.sceneToWorld(e, n) : void 0
			}), a = {
				scale: 1,
				roomSize: c.roomSize
			}, l = (e) => t === x ? e : E(e, t, a), f = Oi(u, t, c.roomSize * .5), p = [];
			return p.push(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="${f.x} ${f.y} ${f.w} ${f.h}">`), p.push(`<rect x="${f.x}" y="${f.y}" width="${f.w}" height="${f.h}" fill="${ji(c.backgroundColor)}"/>`), se(r, {
				state: e,
				viewportBounds: d,
				sceneOverlays: n,
				overlays: this.options.overlays
			}, (e, t) => {
				e.length !== 0 && p.push(...xi(di(t ? e : l(e), Ai)));
			}), p.push("</svg>"), p.join("\n");
		} finally {
			f();
		}
	}
}, Ni = class {
	constructor(e = {}) {
		this.options = e;
	}
	render({ backend: e }) {
		return e.exportCanvas(this.options)?.toDataURL("image/png");
	}
}, Pi = class {
	constructor(e = {}) {
		this.options = e;
	}
	render({ backend: e }) {
		let t = e.exportCanvas(this.options);
		if (!t || !t.toBlob) return;
		let n = t.toBlob.bind(t);
		return new Promise((e) => {
			n((t) => {
				t && e(t);
			}, "image/png");
		});
	}
};
//#endregion
//#region src/export/canvasToBytes.ts
function Fi(e, t = "image/png", n) {
	let r = e.toDataURL(t, n), i = r.indexOf(","), a = i >= 0 ? r.slice(i + 1) : r, o = atob(a), s = new Uint8Array(o.length);
	for (let e = 0; e < o.length; e++) s[e] = o.charCodeAt(e);
	return s;
}
//#endregion
//#region src/export/CanvasExporter.ts
var Ii = class {
	constructor(e) {
		this.options = e;
	}
	render({ state: e, style: t, sceneOverlays: n }) {
		let { currentArea: r, currentZIndex: i, currentAreaInstance: a } = e;
		if (r === void 0 || i === void 0 || !a) return;
		let o = a, s = o.getPlane(i);
		if (!s) return;
		let c = e.settings, { width: l, height: u } = this.options, d = this.options.padding ?? 3, f = e.computeExportBounds(o, s, this.options.roomId, d), p = Oi(f, t, c.roomSize * .5), m = Math.min(l / p.w, u / p.h), h = p.w * m, g = p.h * m, _ = (l - h) / 2 - p.x * m, v = (u - g) / 2 - p.y * m, y = {
			scale: m,
			offsetX: _,
			offsetY: v
		}, b = T.forRenderCamera(l, u, m, _, v), S = {
			forward: t.worldToScene ? (e, n) => t.worldToScene(e, n) : void 0,
			inverse: t.sceneToWorld ? (e, n) => t.sceneToWorld(e, n) : void 0
		}, C = ki(e.mapReader, f);
		try {
			let r = Ie(new w(e.mapReader, c).buildScene(o, s, i, e.lens), b.getViewportBounds(), c, S), a = D.Util.createCanvasElement();
			a.width = l, a.height = u;
			let d = a.getContext("2d");
			if (!d) return;
			d.fillStyle = c.backgroundColor, d.fillRect(0, 0, l, u);
			let p = {
				scale: m,
				roomSize: c.roomSize
			}, h = (e) => t === x ? e : E(e, t, p);
			return se(r, {
				state: e,
				viewportBounds: T.forMapBounds(f.x, f.x + f.w, f.y, f.y + f.h).getViewportBounds(),
				sceneOverlays: n,
				overlays: this.options.overlays
			}, (e, t) => {
				e.length !== 0 && Ti(d, di(t ? e : h(e), y));
			}), a;
		} finally {
			C();
		}
	}
}, Li = class {
	constructor(e) {
		this.options = e, this.canvasExporter = new Ii(e);
	}
	render(e) {
		let t = this.canvasExporter.render(e);
		if (t) return Fi(t, this.options.mimeType, this.options.quality);
	}
}, Z, Ri, zi = 256;
function Bi(e, t, n) {
	let r = `${e.toFixed(2)}:${t}:${n.toFixed(3)}`;
	if (Ri === r && Z) return Z;
	let i = zi, a = i / 2, o = document.createElement("canvas");
	o.width = i, o.height = i;
	let s = o.getContext("2d");
	s.fillStyle = `rgba(0, 0, 0, ${e})`, s.fillRect(0, 0, i, i), s.globalCompositeOperation = "destination-out";
	let c = s.createRadialGradient(a, a, 0, a, a, a), l = Math.min(n, .99);
	c.addColorStop(0, "rgba(0, 0, 0, 1)"), c.addColorStop(l * .25, "rgba(0, 0, 0, 0.97)"), c.addColorStop(l * .5, "rgba(0, 0, 0, 0.82)"), c.addColorStop(l * .7, "rgba(0, 0, 0, 0.50)"), c.addColorStop(l * .85, "rgba(0, 0, 0, 0.22)"), c.addColorStop(l * .95, "rgba(0, 0, 0, 0.06)"), c.addColorStop(l, "rgba(0, 0, 0, 0)"), l < .98 && c.addColorStop(1, "rgba(0, 0, 0, 0)"), s.fillStyle = c, s.beginPath(), s.arc(a, a, a, 0, Math.PI * 2), s.fill(), s.globalCompositeOperation = "source-over";
	let u = parseInt(t.slice(1, 3), 16), d = parseInt(t.slice(3, 5), 16), f = parseInt(t.slice(5, 7), 16), p = s.createRadialGradient(a, a, 0, a, a, a * l);
	return p.addColorStop(0, `rgba(${u}, ${d}, ${f}, 0.05)`), p.addColorStop(1, `rgba(${u}, ${d}, ${f}, 0)`), s.fillStyle = p, s.fillRect(0, 0, i, i), Z = o.toDataURL(), Ri = r, Z;
}
function Vi(e, t, n, r) {
	let { radius: i, intensity: a, color: o } = r, s = n.maxX - n.minX, c = n.maxY - n.minY, l = Math.sqrt(s * s + c * c), u = Math.max(l * 2.5, i * 4);
	return {
		cx: e,
		cy: t,
		displaySize: u,
		src: Bi(a, o, Math.round(i / (u / 2) * 50) / 50)
	};
}
//#endregion
//#region src/overlay/AmbientLightOverlay.ts
var Hi = {
	color: "#ffcc44",
	radius: 12,
	intensity: .7
}, Ui = class {
	constructor(e) {
		this.onPosition = () => this.ctx?.invalidate(), this.params = {
			...Hi,
			...e
		};
	}
	setOptions(e) {
		this.params = {
			...this.params,
			...e
		}, this.ctx?.invalidate();
	}
	getOptions() {
		return { ...this.params };
	}
	attach(e) {
		this.ctx = e, e.state.events.on("position", this.onPosition), this.viewportUnsub = e.onViewportChange(() => e.invalidate());
	}
	detach() {
		this.ctx?.state.events.off("position", this.onPosition), this.viewportUnsub?.(), this.viewportUnsub = void 0, this.ctx = void 0;
	}
	render(e, t) {
		if (e.positionRoomId === void 0) return;
		let n = e.mapReader.getRoom(e.positionRoomId);
		if (!n) return;
		let r = Vi(n.x, n.y, t, this.params);
		return {
			type: "image",
			x: r.cx - r.displaySize / 2,
			y: r.cy - r.displaySize / 2,
			width: r.displaySize,
			height: r.displaySize,
			src: r.src,
			layer: "overlay"
		};
	}
}, Wi = () => typeof performance < "u" ? performance.now() : Date.now(), Gi = typeof requestAnimationFrame < "u" ? requestAnimationFrame : (e) => setTimeout(() => e(Wi()), 16), Ki = typeof cancelAnimationFrame < "u" ? cancelAnimationFrame : (e) => clearTimeout(e), qi = class {
	constructor(e, t, n = {}) {
		this.worldX = e, this.worldY = t, this.cancelled = !1, this.transform = (e, t) => ({
			x: e,
			y: t
		}), this.duration = n.duration ?? 400, this.color = n.color ?? "#00e5b2", this.startRadius = n.startRadius ?? .3, this.endRadius = n.endRadius ?? 1.2, this.strokeWidth = n.strokeWidth ?? .08, this.onComplete = n.onComplete;
	}
	attach(e) {
		let t = this.transform(this.worldX, this.worldY);
		this.ring = new D.Circle({
			x: t.x,
			y: t.y,
			radius: this.startRadius,
			stroke: this.color,
			strokeWidth: this.strokeWidth,
			listening: !1
		}), e.add(this.ring), e.batchDraw();
		let n = (t) => {
			this.ring && (this.ring.radius(this.startRadius + (this.endRadius - this.startRadius) * t), this.ring.opacity(1 - t), e.batchDraw());
		};
		if (this.duration <= 0) {
			n(1), this.onComplete?.();
			return;
		}
		let r = Wi(), i = (e) => {
			if (this.cancelled) return;
			let t = Math.min((e - r) / this.duration, 1);
			n(t), t < 1 ? this.rafId = Gi(i) : (this.rafId = void 0, this.onComplete?.());
		};
		this.rafId = Gi(i);
	}
	updateViewport(e, t, n) {
		if (this.transform = n, this.ring) {
			let e = n(this.worldX, this.worldY);
			this.ring.position({
				x: e.x,
				y: e.y
			});
		}
	}
	destroy() {
		this.cancelled = !0, this.rafId !== void 0 && (Ki(this.rafId), this.rafId = void 0), this.ring?.destroy(), this.ring = void 0;
	}
}, Ji = {
	n: {
		x: 0,
		y: -1
	},
	s: {
		x: 0,
		y: 1
	},
	e: {
		x: 1,
		y: 0
	},
	w: {
		x: -1,
		y: 0
	},
	ne: {
		x: Math.SQRT1_2,
		y: -Math.SQRT1_2
	},
	nw: {
		x: -Math.SQRT1_2,
		y: -Math.SQRT1_2
	},
	se: {
		x: Math.SQRT1_2,
		y: Math.SQRT1_2
	},
	sw: {
		x: -Math.SQRT1_2,
		y: Math.SQRT1_2
	}
}, Yi = [
	"n",
	"s",
	"e",
	"w",
	"ne",
	"nw",
	"se",
	"sw"
], Xi = new Set([
	"ne",
	"nw",
	"se",
	"sw"
]), Zi = {
	clear: 10,
	diagonal: .3,
	preferred: 1,
	distance: .05
}, Qi = [
	"n",
	"s",
	"e",
	"w"
], $i = [
	"n",
	"s",
	"e",
	"w",
	"ne",
	"nw",
	"se",
	"sw"
];
function ea(e, t) {
	return Math.max(0, Math.min(e.x + e.width, t.x + t.width) - Math.max(e.x, t.x)) * Math.max(0, Math.min(e.y + e.height, t.y + t.height) - Math.max(e.y, t.y));
}
function ta(e, t) {
	let n = Math.max(e.x - (t.x + t.width), t.x - (e.x + e.width), 0), r = Math.max(e.y - (t.y + t.height), t.y - (e.y + e.height), 0);
	return Math.hypot(n, r);
}
function Q(e, t, n) {
	let r = Ji[t];
	if (Xi.has(t)) {
		let t = e.x + r.x * n, i = e.y + r.y * n;
		return {
			x: r.x < 0 ? t - e.width : t,
			y: r.y < 0 ? i - e.height : i,
			width: e.width,
			height: e.height
		};
	}
	let i = n + (Math.abs(r.x) * e.width / 2 + Math.abs(r.y) * e.height / 2), a = e.x + r.x * i, o = e.y + r.y * i;
	return {
		x: a - e.width / 2,
		y: o - e.height / 2,
		width: e.width,
		height: e.height
	};
}
function na(e, t, n = {}) {
	let r = n.offset ?? .6, i = n.slots === 4 ? Qi : Yi, a = {
		...Zi,
		...n.weights
	}, o = [], s = [];
	for (let c of e) {
		let e = n.extend ?? 0, l = n.clearCap ?? Math.max(c.width, c.height), u = Math.max(.1, Math.min(c.width, c.height) * .5), d = t.concat(o), f = r + Math.max(c.width, c.height) + e + l, p = d.filter((e) => !(e.kind !== "exit" && c.x >= e.x && c.x <= e.x + e.width && c.y >= e.y && c.y <= e.y + e.height) && e.x < c.x + f && e.x + e.width > c.x - f && e.y < c.y + f && e.y + e.height > c.y - f), m, h = [];
		for (let t of i) {
			let i;
			for (let n = r; n <= r + e + 1e-9; n += u) {
				let e = Q(c, t, n), r = !1, o = Infinity;
				for (let t of p) {
					if (t.kind !== "exit" && ea(e, t) > 0) {
						r = !0;
						break;
					}
					let n = ta(e, t);
					n < o && (o = n);
				}
				if (r) {
					if (i) break;
					continue;
				}
				let s = Math.min(o, l) - n * a.distance;
				(!i || s > i.value) && (i = {
					box: e,
					off: n,
					value: s,
					clearance: o
				});
			}
			if (!i) {
				n.onScored && h.push({
					dir: t,
					valid: !1,
					clearance: 0,
					off: r,
					cost: Infinity,
					box: Q(c, t, r)
				});
				continue;
			}
			let o = 0;
			c.preferred ? t === c.preferred && (o -= a.preferred) : Xi.has(t) && (o += a.diagonal);
			let s = -i.value * a.clear + o;
			n.onScored && h.push({
				dir: t,
				valid: !0,
				clearance: i.clearance,
				off: i.off,
				cost: s,
				box: i.box
			}), (!m || s < m.cost) && (m = {
				box: i.box,
				dir: t,
				off: i.off,
				cost: s,
				clearance: i.clearance
			});
		}
		if (m ||= {
			box: Q(c, i[0], r),
			dir: i[0],
			off: r,
			cost: 0,
			clearance: 0
		}, m.clearance < (n.minClearance ?? 0)) for (let e of $i) {
			let t = Q(c, e, r);
			if (!p.some((e) => e.kind !== "exit" && ea(t, e) > 0)) {
				m = {
					box: t,
					dir: e,
					off: r,
					cost: m.cost,
					clearance: m.clearance
				};
				break;
			}
		}
		n.onScored?.(c, h, m.dir);
		let g = Ji[m.dir];
		s.push({
			id: c.id,
			x: m.box.x,
			y: m.box.y,
			width: c.width,
			height: c.height,
			direction: m.dir,
			leader: {
				x: c.x + g.x * m.off,
				y: c.y + g.y * m.off
			}
		}), o.push({
			...m.box,
			kind: "label"
		});
	}
	return s;
}
//#endregion
//#region src/overlay/WaypointOverlay.ts
var ra = class {
	constructor() {
		this.waypoints = [], this.placed = [];
	}
	set(e) {
		this.waypoints = [...e], this.ctx?.invalidate();
	}
	add(e) {
		this.waypoints.push(e), this.ctx?.invalidate();
	}
	remove(e) {
		let t = this.waypoints.length;
		this.waypoints = this.waypoints.filter((t) => t.roomId !== e), this.waypoints.length !== t && this.ctx?.invalidate();
	}
	has(e) {
		return this.waypoints.some((t) => t.roomId === e);
	}
	hitTest(e, t) {
		for (let n = this.placed.length - 1; n >= 0; n--) {
			let r = this.placed[n];
			if (e >= r.x && e <= r.x + r.width && t >= r.y && t <= r.y + r.height) return r.wp;
		}
	}
	attach(e) {
		this.ctx = e;
	}
	detach() {
		this.ctx = void 0, this.placed = [];
	}
	render(e, t) {
		this.placed = [];
		let n = e.currentArea, r = e.currentZIndex;
		if (n === void 0 || r === void 0 || this.waypoints.length === 0) return [];
		let i = e.currentAreaInstance?.getPlane(r);
		if (!i) return [];
		let a = e.settings.roomSize, o = a * .6, s = o * .5, c = o * 1.2, l = i.getRooms(), u = l.map((e) => ({
			x: e.x - a / 2,
			y: e.y - a / 2,
			width: a,
			height: a,
			kind: "room"
		})), d = (e, t, n, r) => u.push({
			x: Math.min(e, n) - .03,
			y: Math.min(t, r) - .03,
			width: Math.abs(n - e) + .06,
			height: Math.abs(r - t) + .06,
			kind: "exit"
		});
		for (let t of l) for (let i of [...Object.values(t.exits), ...Object.values(t.specialExits)]) {
			let a = e.mapReader.getRoom(i);
			a && a.area === n && a.z === r && d(t.x, t.y, a.x, a.y);
		}
		let f = [], p = [];
		for (let t of this.waypoints) {
			let i = e.mapReader.getRoom(t.roomId);
			if (!i || i.area !== n || i.z !== r) continue;
			let a = Array.isArray(t.label) ? t.label : [t.label], l = a.reduce((e, t) => Math.max(e, t.length), 0) * o * .6 + s * 2, u = a.length * c + o * .4;
			f.push({
				x: i.x,
				y: i.y,
				width: l,
				height: u,
				id: f.length,
				preferred: t.preferred
			}), p.push({
				wp: t,
				rx: i.x,
				ry: i.y,
				lines: a
			});
		}
		if (f.length === 0) return [];
		let m = "rgba(20, 20, 24, 0.82)", h = na(f, u, {
			offset: a * .7,
			extend: a * 4,
			clearCap: a * 1.5,
			minClearance: a * .7
		}), g = [];
		for (let t = 0; t < h.length; t++) {
			let n = h[t], { wp: r, rx: i, ry: s } = p[t], l = r.color ?? "#ffcc33", u = i - (n.x + n.width / 2), d = s - (n.y + n.height / 2), f = Math.hypot(u, d) || 1, _ = u / f, v = d / f, y = o * .7, b = o * .5, x = n.direction.length === 2, S;
			if (x) {
				let e = _ < 0 ? n.x : n.x + n.width, t = v < 0 ? n.y : n.y + n.height, r = o * .85;
				S = [
					e + (_ < 0 ? r : -r),
					t,
					e + _ * y,
					t + v * y,
					e,
					t + (v < 0 ? r : -r)
				];
			} else {
				let e = Math.abs(u), t = Math.abs(d), r = (e > 1e-6 ? n.width / 2 / e : Infinity) <= (t > 1e-6 ? n.height / 2 / t : Infinity), i = r ? _ < 0 ? n.x : n.x + n.width : n.x + n.width / 2, a = r ? n.y + n.height / 2 : v < 0 ? n.y : n.y + n.height, o = +!r, s = +!!r;
				S = [
					i + o * b,
					a + s * b,
					i + _ * y,
					a + v * y,
					i - o * b,
					a - s * b
				];
			}
			g.push({
				type: "polygon",
				vertices: S,
				paint: {
					fill: m,
					stroke: l,
					strokeWidth: a * .03
				},
				layer: "top"
			}), g.push({
				type: "rect",
				x: n.x,
				y: n.y,
				width: n.width,
				height: n.height,
				cornerRadius: o * .3,
				paint: {
					fill: m,
					stroke: l,
					strokeWidth: a * .03
				},
				layer: "top"
			}), this.placed.push({
				wp: r,
				x: n.x,
				y: n.y,
				width: n.width,
				height: n.height
			});
			let C = p[t].lines, ee = (n.height - C.length * c) / 2;
			for (let t = 0; t < C.length; t++) g.push({
				type: "text",
				x: n.x,
				y: n.y + ee + t * c,
				width: n.width,
				height: c,
				text: C[t],
				fontSize: o,
				fontFamily: e.settings.fontFamily,
				fill: "#f4f4f6",
				align: "center",
				verticalAlign: "middle",
				layer: "top"
			});
		}
		return g;
	}
}, ia = /* @__PURE__ */ O(((e, t) => {
	t.exports = class {
		constructor() {
			this.keys = /* @__PURE__ */ new Set(), this.queue = [];
		}
		sort() {
			this.queue.sort((e, t) => e.priority - t.priority);
		}
		set(e, t) {
			let n = Number(t);
			if (isNaN(n)) throw TypeError("\"priority\" must be a number");
			return this.keys.has(e) ? this.queue.map((t) => (t.key === e && Object.assign(t, { priority: n }), t)) : (this.keys.add(e), this.queue.push({
				key: e,
				priority: n
			})), this.sort(), this.queue.length;
		}
		next() {
			let e = this.queue.shift();
			return this.keys.delete(e.key), e;
		}
		isEmpty() {
			return this.queue.length === 0;
		}
		has(e) {
			return this.keys.has(e);
		}
		get(e) {
			return this.queue.find((t) => t.key === e);
		}
	};
})), aa = /* @__PURE__ */ O(((e, t) => {
	function n(e, t) {
		let r = /* @__PURE__ */ new Map();
		for (let [i, a] of e) i !== t && a instanceof Map ? r.set(i, n(a, t)) : i !== t && r.set(i, a);
		return r;
	}
	t.exports = n;
})), oa = /* @__PURE__ */ O(((e, t) => {
	function n(e) {
		let t = Number(e);
		return !(isNaN(t) || t <= 0);
	}
	function r(e) {
		let t = /* @__PURE__ */ new Map();
		return Object.keys(e).forEach((i) => {
			let a = e[i];
			if (typeof a == "object" && a && !Array.isArray(a)) return t.set(i, r(a));
			if (!n(a)) throw Error(`Could not add node at key "${i}", make sure it's a valid node`, a);
			return t.set(i, Number(a));
		}), t;
	}
	t.exports = r;
})), sa = /* @__PURE__ */ O(((e, t) => {
	function n(e) {
		if (!(e instanceof Map)) throw Error(`Invalid graph: Expected Map instead found ${typeof e}`);
		e.forEach((e, t) => {
			if (typeof e == "object" && e instanceof Map) {
				n(e);
				return;
			}
			if (typeof e != "number" || e <= 0) throw Error(`Values must be numbers greater than 0. Found value ${e} at ${t}`);
		});
	}
	t.exports = n;
})), ca = /* @__PURE__ */ De((/* @__PURE__ */ O(((e, t) => {
	var n = ia(), r = aa(), i = oa(), a = sa();
	t.exports = class {
		constructor(e) {
			e instanceof Map ? (a(e), this.graph = e) : e ? this.graph = i(e) : this.graph = /* @__PURE__ */ new Map();
		}
		addNode(e, t) {
			let n;
			return t instanceof Map ? (a(t), n = t) : n = i(t), this.graph.set(e, n), this;
		}
		addVertex(e, t) {
			return this.addNode(e, t);
		}
		removeNode(e) {
			return this.graph = r(this.graph, e), this;
		}
		path(e, t, r = {}) {
			if (!this.graph.size) return r.cost ? {
				path: null,
				cost: 0
			} : null;
			let i = /* @__PURE__ */ new Set(), a = new n(), o = /* @__PURE__ */ new Map(), s = [], c = 0, l = [];
			if (r.avoid && (l = [].concat(r.avoid)), l.includes(e)) throw Error(`Starting node (${e}) cannot be avoided`);
			if (l.includes(t)) throw Error(`Ending node (${t}) cannot be avoided`);
			for (a.set(e, 0); !a.isEmpty();) {
				let e = a.next();
				if (e.key === t) {
					c = e.priority;
					let t = e.key;
					for (; o.has(t);) s.push(t), t = o.get(t);
					break;
				}
				i.add(e.key), (this.graph.get(e.key) || /* @__PURE__ */ new Map()).forEach((t, n) => {
					if (i.has(n) || l.includes(n)) return null;
					if (!a.has(n)) return o.set(n, e.key), a.set(n, e.priority + t);
					let r = a.get(n).priority, s = e.priority + t;
					return s < r ? (o.set(n, e.key), a.set(n, s)) : null;
				});
			}
			return s.length ? (r.trim ? s.shift() : s = s.concat([e]), r.reverse || (s = s.reverse()), r.cost ? {
				path: s,
				cost: c
			} : s) : r.cost ? {
				path: null,
				cost: 0
			} : null;
		}
		shortestPath(...e) {
			return this.path(...e);
		}
	};
})))(), 1), la = {
	1: "north",
	2: "northeast",
	3: "northwest",
	4: "east",
	5: "west",
	6: "south",
	7: "southeast",
	8: "southwest",
	9: "up",
	10: "down",
	11: "in",
	12: "out"
}, ua = {
	north: "n",
	northeast: "ne",
	northwest: "nw",
	east: "e",
	west: "w",
	south: "s",
	southeast: "se",
	southwest: "sw",
	up: "up",
	down: "down",
	in: "in",
	out: "out"
}, da = class {
	constructor(e) {
		this.mapReader = e, this.data = this.buildGraph();
	}
	getAdj() {
		return this.data.adj;
	}
	getGraphDefinition() {
		return this.data.graphDefinition;
	}
	getMaxEdgeDistance() {
		return this.data.maxEdgeDistance;
	}
	getMinEdgeWeight() {
		return this.data.minEdgeWeight;
	}
	getRoom(e) {
		return this.mapReader.getRoom(e);
	}
	resolveEdgeWeight(e, t, n) {
		let r = e.exitWeights?.[t];
		return r !== void 0 && r > 0 ? r : Math.max(n.weight, 1);
	}
	buildGraph() {
		let e = /* @__PURE__ */ new Map(), t = {}, n = 1, r = Infinity;
		return this.mapReader.getRooms().forEach((i) => {
			let a = [], o = {}, s = new Set((i.exitLocks ?? []).map((e) => la[e]).filter((e) => !!e)), c = new Set(i.mSpecialExitLocks ?? []);
			Object.entries(i.exits ?? {}).forEach(([e, t]) => {
				if (s.has(e)) return;
				let c = this.mapReader.getRoom(t);
				if (c) {
					let s = ua[e] ?? e, l = this.resolveEdgeWeight(i, s, c);
					a.push({
						id: t,
						weight: l
					}), o[t.toString()] = l, l < r && (r = l);
					let u = c.x - i.x, d = c.y - i.y, f = c.z - i.z, p = Math.sqrt(u * u + d * d + f * f);
					p > n && (n = p);
				}
			}), Object.entries(i.specialExits ?? {}).forEach(([e, t]) => {
				if (c.has(t)) return;
				let s = this.mapReader.getRoom(t);
				if (s) {
					let c = this.resolveEdgeWeight(i, e, s);
					a.push({
						id: t,
						weight: c
					}), o[t.toString()] = c, c < r && (r = c);
					let l = s.x - i.x, u = s.y - i.y, d = s.z - i.z, f = Math.sqrt(l * l + u * u + d * d);
					f > n && (n = f);
				}
			}), e.set(i.id, a), t[i.id.toString()] = o;
		}), isFinite(r) || (r = 1), {
			adj: e,
			graphDefinition: t,
			maxEdgeDistance: n,
			minEdgeWeight: r
		};
	}
};
//#endregion
//#region src/PathFinder.ts
function fa(e, t) {
	e.push(t);
	let n = e.length - 1;
	for (; n > 0;) {
		let t = n - 1 >> 1;
		if (e[t].priority <= e[n].priority) break;
		[e[t], e[n]] = [e[n], e[t]], n = t;
	}
}
function pa(e) {
	if (e.length === 0) return;
	let t = e[0], n = e.pop();
	if (e.length > 0) {
		e[0] = n;
		let t = 0, r = e.length;
		for (;;) {
			let n = t, i = 2 * t + 1, a = 2 * t + 2;
			if (i < r && e[i].priority < e[n].priority && (n = i), a < r && e[a].priority < e[n].priority && (n = a), n === t) break;
			[e[t], e[n]] = [e[n], e[t]], t = n;
		}
	}
	return t;
}
function ma(e, t, n) {
	let r = [n], i = n;
	for (; i !== t;) i = e.get(i), r.push(i);
	return r.reverse(), r;
}
function ha(e, t, n) {
	let r = e.path(t.toString(), n.toString()), i = Array.isArray(r) ? r : r?.path;
	return i ? i.map((e) => Number(e)) : null;
}
function ga(e, t, n, r) {
	let i = r.getRoom(n);
	if (!i) return null;
	let a = i.x, o = i.y, s = i.z, c = r.getMaxEdgeDistance(), l = r.getMinEdgeWeight(), u = (e) => {
		let t = r.getRoom(e);
		if (!t) return 0;
		let n = t.x - a, i = t.y - o, u = t.z - s;
		return Math.sqrt(n * n + i * i + u * u) / c * l;
	}, d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), p = [];
	for (d.set(t, 0), fa(p, {
		id: t,
		priority: u(t)
	}); p.length > 0;) {
		let { id: r } = pa(p);
		if (r === n) return ma(f, t, n);
		let i = d.get(r) ?? Infinity, a = e.get(r);
		if (a) for (let e of a) {
			let t = i + e.weight;
			t < (d.get(e.id) ?? Infinity) && (d.set(e.id, t), f.set(e.id, r), fa(p, {
				id: e.id,
				priority: t + u(e.id)
			}));
		}
	}
	return null;
}
var _a = class {
	constructor(e, t = "dijkstra") {
		this.cache = /* @__PURE__ */ new Map(), this._algorithm = t, this.mapGraph = new da(e), this.dijkstraGraph = new ca.default(this.mapGraph.getGraphDefinition());
	}
	get algorithm() {
		return this._algorithm;
	}
	setAlgorithm(e) {
		e !== this._algorithm && (this._algorithm = e, this.cache.clear());
	}
	findPath(e, t) {
		let n = `${e}->${t}`;
		if (this.cache.has(n)) return this.cache.get(n);
		if (e === t) {
			let t = this.mapGraph.getRoom(e) ? [e] : null;
			return this.cache.set(n, t), t;
		}
		if (!this.mapGraph.getRoom(e) || !this.mapGraph.getRoom(t)) return this.cache.set(n, null), null;
		let r;
		switch (this._algorithm) {
			case "dijkstra":
				r = ha(this.dijkstraGraph, e, t);
				break;
			case "astar":
				r = ga(this.mapGraph.getAdj(), e, t, this.mapGraph);
				break;
		}
		return this.cache.set(n, r), r;
	}
};
//#endregion
//#region src/reader/HashLookup.ts
function va(e) {
	return !!e && e.hashLookupCapable === !0;
}
//#endregion
//#region src/lens/composeLenses.ts
var $ = {
	hidden: 2,
	stub: 1,
	full: 0
};
function ya(e, t, n) {
	return n === "first" ? e : n === "least-restrictive" ? $[e] < $[t] ? e : t : $[e] > $[t] ? e : t;
}
function ba(e, ...t) {
	let n = {}, r;
	e && typeof e.isVisible == "function" ? r = [e, ...t] : (n = e ?? {}, r = t);
	let i = n.exitStrategy ?? "most-restrictive", a = n.visibility ?? "and";
	return r.length === 0 ? {
		isVisible: () => !0,
		getVersion: () => 0
	} : r.length === 1 ? r[0] : {
		isVisible(e) {
			return a === "or" ? r.some((t) => t.isVisible(e)) : r.every((t) => t.isVisible(e));
		},
		getExitTreatment(e, t, n) {
			let a;
			for (let o of r) {
				let r = o.getExitTreatment ? o.getExitTreatment(e, t, n) : d(o, e, t, n);
				if (a === void 0) a = r;
				else if (a = ya(a, r, i), i === "first") break;
			}
			return a ?? "full";
		},
		getVersion() {
			let e = 0;
			for (let t of r) e += t.getVersion();
			return e;
		}
	};
}
//#endregion
//#region src/lens/ExplorationLens.ts
var xa = class {
	constructor(e) {
		this.version = 0, this.visited = e instanceof Set ? new Set(e) : new Set(e ?? []);
	}
	isVisible(e) {
		return this.visited.has(e.id);
	}
	getVersion() {
		return this.version;
	}
	hasVisited(e) {
		return this.visited.has(e);
	}
	getVisitedRoomIds() {
		return [...this.visited];
	}
	getVisitedCount() {
		return this.visited.size;
	}
	addVisited(e) {
		return this.visited.has(e) ? !1 : (this.visited.add(e), this.version++, !0);
	}
	addVisitedAll(e) {
		let t = 0;
		for (let n of e) this.visited.has(n) || (this.visited.add(n), t++);
		return t > 0 && this.version++, t;
	}
	setVisited(e) {
		this.visited.clear();
		for (let t of e) this.visited.add(t);
		this.version++;
	}
	clear() {
		this.visited.size !== 0 && (this.visited.clear(), this.version++);
	}
}, Sa = {
	1: "north",
	2: "northeast",
	3: "northwest",
	4: "east",
	5: "west",
	6: "south",
	7: "southeast",
	8: "southwest",
	9: "up",
	10: "down",
	11: "in",
	12: "out"
};
function Ca() {
	return {
		areaWidth: 150,
		areaHeight: 80,
		areaSpacing: 50,
		fontSize: 14,
		connectionLineWidth: 2,
		areaFillColor: "#2a2a3e",
		areaStrokeColor: "#4a4a6e",
		textColor: "#e0e0e0",
		connectionColor: "#6a6a8e",
		highlightColor: "#ff9900"
	};
}
var wa = class {
	constructor(e, t, n) {
		this.areaNodes = /* @__PURE__ */ new Map(), this.connectionGroups = [], this.currentZoom = 1, this.domainInfo = /* @__PURE__ */ new Map(), this.domainFilter = "all", this.dotsMode = !1, this.settings = n ?? Ca(), this.stage = new D.Stage({
			container: e,
			width: e.clientWidth,
			height: e.clientHeight,
			draggable: !0
		}), this.backgroundLayer = new D.Layer({ listening: !1 }), this.stage.add(this.backgroundLayer), this.connectionLayer = new D.Layer({ listening: !1 }), this.stage.add(this.connectionLayer), this.areaLayer = new D.Layer(), this.stage.add(this.areaLayer), this.mapReader = t, this.initScaling(), this.initResize(e);
	}
	initResize(e) {
		new ResizeObserver(() => {
			this.stage.width(e.clientWidth), this.stage.height(e.clientHeight), this.stage.batchDraw();
		}).observe(e);
	}
	initScaling() {
		let e = 1.1;
		this.stage.on("wheel", (t) => {
			t.evt.preventDefault();
			let n = this.stage.scaleX(), r = this.stage.getPointerPosition();
			if (!r) return;
			let i = {
				x: (r.x - this.stage.x()) / n,
				y: (r.y - this.stage.y()) / n
			}, a = (t.evt.deltaY > 0 ? -1 : 1) > 0 ? this.currentZoom * e : this.currentZoom / e;
			if (this.setZoom(a)) {
				let e = this.stage.scaleX(), t = {
					x: r.x - i.x * e,
					y: r.y - i.y * e
				};
				this.stage.position(t), this.stage.batchDraw();
			}
		});
	}
	setZoom(e) {
		let t = Math.max(.1, e);
		return this.currentZoom === t ? !1 : (this.currentZoom = t, this.stage.scale({
			x: this.currentZoom,
			y: this.currentZoom
		}), !0);
	}
	getZoom() {
		return this.currentZoom;
	}
	setDomainInfo(e) {
		this.domainInfo.clear();
		for (let [t, n] of Object.entries(e)) this.domainInfo.set(Number(t), n);
	}
	setDomainFilter(e) {
		this.domainFilter = e;
	}
	getDomainFilter() {
		return this.domainFilter;
	}
	setBackgroundImage(e) {
		this.backgroundConfig = {
			url: e.url,
			x: e.x,
			y: e.y,
			width: e.width,
			height: e.height,
			opacity: e.opacity ?? .3
		};
	}
	clearBackgroundImage() {
		this.backgroundConfig = void 0, this.backgroundImage = void 0, this.backgroundLayer.destroyChildren(), this.backgroundLayer.batchDraw();
	}
	redrawBackground() {
		this.drawBackground();
	}
	setDotsMode(e) {
		this.dotsMode = e;
	}
	getDotsMode() {
		return this.dotsMode;
	}
	redraw() {
		this.drawBackground(), this.drawConnections(), this.drawAreas(), this.stage.batchDraw();
	}
	isAreaInDomain(e) {
		let t = this.domainInfo.get(e);
		if (!t) return this.domainFilter === "interdomain" || this.domainFilter === "all";
		switch (this.domainFilter) {
			case "ishtar": return t.isIshtar;
			case "empire": return t.isEmpire;
			case "interdomain": return !t.isIshtar && !t.isEmpire;
			case "all": return !0;
		}
	}
	areAreasInSameDomain(e, t) {
		let n = this.domainInfo.get(e), r = this.domainInfo.get(t);
		return !n || !r ? !1 : n.isIshtar && r.isIshtar || n.isEmpire && r.isEmpire ? !0 : !n.isIshtar && !n.isEmpire && !r.isIshtar && !r.isEmpire;
	}
	render() {
		this.analyzeConnections(), this.layoutAreas(), this.drawBackground(), this.drawConnections(), this.drawAreas(), this.centerView(), this.stage.batchDraw();
	}
	drawBackground() {
		if (this.backgroundLayer.destroyChildren(), !this.backgroundConfig) return;
		let e = new Image();
		e.crossOrigin = "anonymous", e.onload = () => {
			this.backgroundImage = new D.Image({
				x: this.backgroundConfig.x,
				y: this.backgroundConfig.y,
				image: e,
				width: this.backgroundConfig.width,
				height: this.backgroundConfig.height,
				opacity: this.backgroundConfig.opacity,
				listening: !1
			}), this.backgroundLayer.add(this.backgroundImage), this.backgroundLayer.batchDraw();
		}, e.onerror = () => {
			console.error("Failed to load background image:", this.backgroundConfig?.url);
		}, e.src = this.backgroundConfig.url;
	}
	analyzeConnections() {
		this.areaNodes.clear(), this.connectionGroups = [];
		let e = this.mapReader.getRooms(), t = this.mapReader.getAreas(), n = /* @__PURE__ */ new Map();
		for (let e of t) {
			let t = e.getAreaId(), r = e.getRooms();
			if (r.length === 0) continue;
			let i = Infinity, a = -Infinity, o = Infinity, s = -Infinity, c = 0;
			for (let e of r) e.z === 0 && (c++, i = Math.min(i, e.x), a = Math.max(a, e.x), o = Math.min(o, e.y), s = Math.max(s, e.y));
			if (c === 0) for (let e of r) i = Math.min(i, e.x), a = Math.max(a, e.x), o = Math.min(o, e.y), s = Math.max(s, e.y);
			let l = (i + a) / 2, u = (o + s) / 2;
			n.set(t, {
				minX: i,
				maxX: a,
				minY: o,
				maxY: s,
				centerX: l,
				centerY: u,
				roomCount: r.length
			});
		}
		let i = 1;
		for (let e of n.values()) {
			let t = e.maxX - e.minX, n = e.maxY - e.minY;
			i = Math.max(i, t, n);
		}
		let a = 200 / i;
		for (let e of t) {
			let t = e.getAreaId(), r = n.get(t);
			if (!r || !this.isAreaInDomain(t)) continue;
			let i = r.maxX - r.minX, o = r.maxY - r.minY, s = Math.max(100, i * a), c = Math.max(100, o * a), l = s / c;
			l > 3 ? c = s / 3 : l < 1 / 3 && (s = c / 3), this.areaNodes.set(t, {
				areaId: t,
				name: e.getAreaName(),
				x: 0,
				y: 0,
				width: s,
				height: c,
				connections: [],
				roomCount: r.roomCount,
				realCenterX: r.centerX,
				realCenterY: r.centerY
			});
		}
		let o = /* @__PURE__ */ new Map();
		for (let t of e) {
			let e = t.area;
			if (!this.areaNodes.has(e)) continue;
			let n = this.getLockedDirections(t), r = new Set(t.mSpecialExitLocks ?? []);
			for (let [r, i] of Object.entries(t.exits ?? {})) {
				if (n.has(r)) continue;
				let a = this.mapReader.getRoom(i);
				if (!a || a.area === e || !this.areaNodes.has(a.area) || !this.areAreasInSameDomain(e, a.area)) continue;
				let s = this.createConnection(t, a, r);
				s && this.addConnection(o, s);
			}
			for (let [n, i] of Object.entries(t.specialExits ?? {})) {
				if (r.has(i)) continue;
				let a = this.mapReader.getRoom(i);
				if (!a || a.area === e || !this.areaNodes.has(a.area) || !this.areAreasInSameDomain(e, a.area)) continue;
				let s = this.parseDirection(n), c = this.createConnection(t, a, s);
				c && this.addConnection(o, c);
			}
		}
		for (let [e, t] of o) {
			let [n, i] = e.split("-").map(Number), a = this.createConnectionGroup(n, i, t);
			this.connectionGroups.push(a);
			let o = this.areaNodes.get(n), s = this.areaNodes.get(i);
			if (o && o.connections.push(...t), s) for (let e of t) s.connections.push({
				...e,
				fromAreaId: e.toAreaId,
				toAreaId: e.fromAreaId,
				fromRoomId: e.toRoomId,
				toRoomId: e.fromRoomId,
				direction: e.direction ? r[e.direction] : null,
				fromRoomPosition: e.toRoomPosition,
				toRoomPosition: e.fromRoomPosition
			});
		}
	}
	getLockedDirections(e) {
		return new Set((e.exitLocks ?? []).map((e) => Sa[e]).filter((e) => !!e));
	}
	createConnection(e, t, n) {
		let r = this.toPlanarDirection(n);
		return {
			fromAreaId: e.area,
			toAreaId: t.area,
			fromRoomId: e.id,
			toRoomId: t.id,
			direction: r,
			fromRoomPosition: {
				x: e.x,
				y: e.y
			},
			toRoomPosition: {
				x: t.x,
				y: t.y
			}
		};
	}
	addConnection(e, t) {
		let n = t.fromAreaId < t.toAreaId ? `${t.fromAreaId}-${t.toAreaId}` : `${t.toAreaId}-${t.fromAreaId}`;
		e.has(n) || e.set(n, []), e.get(n).push(t);
	}
	createConnectionGroup(e, t, n) {
		let r = /* @__PURE__ */ new Map(), i = 0, a = 0;
		for (let e of n) e.direction && r.set(e.direction, (r.get(e.direction) ?? 0) + 1), i += e.toRoomPosition.x - e.fromRoomPosition.x, a += e.toRoomPosition.y - e.fromRoomPosition.y;
		let o = null, s = 0;
		for (let [e, t] of r) t > s && (s = t, o = e);
		return {
			fromAreaId: e,
			toAreaId: t,
			connections: n,
			primaryDirection: o,
			averageOffset: {
				x: i / n.length,
				y: a / n.length
			}
		};
	}
	parseDirection(e) {
		return {
			n: "north",
			north: "north",
			s: "south",
			south: "south",
			e: "east",
			east: "east",
			w: "west",
			west: "west",
			ne: "northeast",
			northeast: "northeast",
			nw: "northwest",
			northwest: "northwest",
			se: "southeast",
			southeast: "southeast",
			sw: "southwest",
			southwest: "southwest",
			u: "up",
			up: "up",
			d: "down",
			down: "down",
			i: "in",
			in: "in",
			o: "out",
			out: "out"
		}[e.toLowerCase().trim()] ?? null;
	}
	toPlanarDirection(e) {
		return e && f.includes(e) ? e : null;
	}
	layoutAreas() {
		if (Array.from(this.areaNodes.values()).length === 0) return;
		let e = this.findConnectedComponents(), t = 0, n = this.settings.areaWidth * 3;
		for (let r of e) if (r.length === 1) {
			let e = this.areaNodes.get(r[0]);
			e && (e.x = t, e.y = 0), t += this.settings.areaWidth + n;
		} else {
			let e = this.forceDirectedLayout(r);
			for (let n of r) {
				let r = this.areaNodes.get(n);
				r && isFinite(e.minX) && isFinite(e.minY) && (r.x -= e.minX, r.x += t, r.y -= e.minY);
			}
			let i = isFinite(e.maxX - e.minX) ? e.maxX - e.minX : this.settings.areaWidth;
			t += i + n;
		}
	}
	findConnectedComponents() {
		let e = /* @__PURE__ */ new Set(), t = [];
		for (let [n] of this.areaNodes) {
			if (e.has(n)) continue;
			let r = [], i = [n];
			for (; i.length > 0;) {
				let t = i.shift();
				if (e.has(t)) continue;
				e.add(t), r.push(t);
				let n = this.areaNodes.get(t);
				if (n) for (let t of n.connections) e.has(t.toAreaId) || i.push(t.toAreaId);
			}
			t.push(r);
		}
		return t;
	}
	forceDirectedLayout(e) {
		let t = /* @__PURE__ */ new Map();
		for (let n of e) {
			let e = this.areaNodes.get(n);
			if (!e) continue;
			let r = new Set(e.connections.map((e) => e.toAreaId));
			t.set(n, r);
		}
		let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
		for (let [e, r] of t) r.size >= 3 && n.add(e);
		for (let [e, i] of t) {
			if (n.has(e) || r.has(e) || i.size > 2) continue;
			let a = [e];
			r.add(e);
			let o = Array.from(i);
			for (let i of o) {
				let o = i, s = e;
				for (; o && !r.has(o) && !n.has(o);) {
					let e = t.get(o);
					if (!e) break;
					if (e.size >= 3) {
						n.add(o);
						break;
					}
					a.push(o), r.add(o);
					let i = !1;
					for (let t of e) if (t !== s && !r.has(t)) {
						s = o, o = t, i = !0;
						break;
					}
					if (!i) break;
				}
			}
			let s = !1;
			for (let e of a) {
				let r = t.get(e);
				if (r) {
					for (let e of r) if (n.has(e)) {
						s = !0;
						break;
					}
				}
				if (s) break;
			}
			if (!s && a.length > 0) {
				let e = a[0], i = t.get(a[0])?.size ?? 0;
				for (let n of a) {
					let r = t.get(n)?.size ?? 0;
					r > i && (i = r, e = n);
				}
				n.add(e), r.delete(e);
			}
		}
		for (let r of e) {
			let e = t.get(r);
			(!e || e.size === 0) && n.add(r);
		}
		let i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
		for (let e of n) i.set(e, e), a.set(e, []);
		let o = new Set(n);
		for (let e of n) {
			let n = t.get(e) ?? /* @__PURE__ */ new Set();
			for (let r of n) {
				if (o.has(r)) continue;
				let n = [], s = r, c = e;
				for (; s && !o.has(s);) {
					n.push(s), i.set(s, e), o.add(s);
					let r = t.get(s) ?? /* @__PURE__ */ new Set(), a;
					for (let e of r) if (e !== c && !o.has(e)) {
						a = e;
						break;
					}
					c = s, s = a;
				}
				n.length > 0 && a.get(e).push(n);
			}
		}
		let s = /* @__PURE__ */ new Set(), c = [], l = n.values().next().value, u = l === void 0 ? e[0] : l;
		if (u !== void 0) {
			let e = this.areaNodes.get(u);
			e && (e.x = 0, e.y = 0, s.add(u), c.push(u));
		}
		for (; c.length > 0;) {
			let e = c.shift(), t = this.areaNodes.get(e), r = /* @__PURE__ */ new Map();
			for (let e of t.connections) {
				let t = e.toAreaId;
				if (s.has(t) || !n.has(t)) continue;
				let i = this.areaNodes.get(t);
				if (!i) continue;
				let a = e.direction ?? "none";
				r.has(a) || r.set(a, []), r.get(a).push({
					id: t,
					node: i,
					conn: e
				});
			}
			for (let [e, n] of r) {
				let r = this.getDirectionOffset(e === "none" ? null : e);
				n.sort((e, t) => Math.abs(r.x) > Math.abs(r.y) ? t.node.realCenterY - e.node.realCenterY : e.node.realCenterX - t.node.realCenterX);
				let i = this.settings.areaWidth + this.settings.areaSpacing, a = this.settings.areaHeight + this.settings.areaSpacing;
				n.forEach((e, o) => {
					if (e.node.x = t.x + r.x * i, e.node.y = t.y + r.y * a, n.length > 1) {
						let t = (o - (n.length - 1) / 2) * .5;
						Math.abs(r.x) > Math.abs(r.y) ? e.node.y += t * a : e.node.x += t * i;
					}
					s.add(e.id), c.push(e.id);
				});
			}
		}
		let d = Array.from(n);
		d.length > 1 && this.applyForces(d, 80);
		let f = this.settings.areaWidth + this.settings.areaSpacing + 30, p = this.settings.areaHeight + this.settings.areaSpacing + 30, m = /* @__PURE__ */ new Map(), h = [
			"east",
			"west",
			"north",
			"south",
			"northeast",
			"northwest",
			"southeast",
			"southwest"
		];
		for (let [e, t] of a) {
			let n = this.areaNodes.get(e);
			if (!n) continue;
			let r = 0, i = /* @__PURE__ */ new Map();
			for (let a of t) {
				let t = e, o = n.x, s = n.y, c = null;
				for (let l of a) {
					let a = this.areaNodes.get(l);
					if (!a) continue;
					let u = this.areaNodes.get(t), d = null;
					if (u) {
						for (let e of u.connections) if (e.toAreaId === l) {
							d = e.direction;
							break;
						}
					}
					!d && t === e ? (c = h[r % h.length], r++, d = c) : !d && c && (d = c);
					let g = this.getDirectionOffset(d), _ = 0;
					if (t === e && d) {
						let e = d, t = i.get(e) ?? 0;
						i.set(e, t + 1), _ = t;
					}
					if (a.x = o + g.x * f, a.y = s + g.y * p, _ > 0) {
						let e = 1.2;
						g.x !== 0 && g.y === 0 ? a.y += _ * p * e : g.y !== 0 && g.x === 0 ? a.x += _ * f * e : (a.x += _ * f * e, a.y -= _ * p * e);
					}
					m.set(l, {
						dx: a.x - n.x,
						dy: a.y - n.y,
						hubId: e
					}), t = l, o = a.x, s = a.y;
				}
			}
		}
		let g = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Map();
		for (let e of n) {
			let t = this.areaNodes.get(e);
			if (!t) continue;
			let n = t.x, r = t.y, i = t.x + t.width, o = t.y + t.height, s = a.get(e) ?? [];
			for (let e of s) for (let t of e) {
				let e = this.areaNodes.get(t);
				e && (n = Math.min(n, e.x), r = Math.min(r, e.y), i = Math.max(i, e.x + e.width), o = Math.max(o, e.y + e.height));
			}
			g.set(e, {
				minX: n,
				minY: r,
				maxX: i,
				maxY: o
			}), _.set(e, {
				dx: n - t.x,
				dy: r - t.y
			});
		}
		this.applyClusterForces(d, g, _, 60);
		for (let [e, t] of m) {
			let n = this.areaNodes.get(e), r = this.areaNodes.get(t.hubId);
			!n || !r || (n.x = r.x + t.dx, n.y = r.y + t.dy);
		}
		let v = Infinity, y = Infinity, b = -Infinity, x = -Infinity;
		for (let t of e) {
			let e = this.areaNodes.get(t);
			v = Math.min(v, e.x), y = Math.min(y, e.y), b = Math.max(b, e.x + e.width), x = Math.max(x, e.y + e.height);
		}
		return {
			minX: v,
			minY: y,
			maxX: b,
			maxY: x
		};
	}
	getDirectionOffset(e) {
		let t = {
			north: {
				x: 0,
				y: -1
			},
			south: {
				x: 0,
				y: 1
			},
			east: {
				x: 1,
				y: 0
			},
			west: {
				x: -1,
				y: 0
			},
			northeast: {
				x: .75,
				y: -.75
			},
			northwest: {
				x: -.75,
				y: -.75
			},
			southeast: {
				x: .75,
				y: .75
			},
			southwest: {
				x: -.75,
				y: .75
			}
		};
		return e && t[e] ? t[e] : {
			x: 1,
			y: 0
		};
	}
	applyClusterForces(e, t, n, r) {
		let i = .8, a = /* @__PURE__ */ new Map();
		for (let t of e) a.set(t, {
			vx: 0,
			vy: 0
		});
		for (let o = 0; o < r; o++) {
			for (let r of e) {
				let e = this.areaNodes.get(r), i = t.get(r), a = n.get(r);
				if (!e || !i || !a) continue;
				let o = i.maxX - i.minX, s = i.maxY - i.minY;
				i.minX = e.x + a.dx, i.minY = e.y + a.dy, i.maxX = i.minX + o, i.maxY = i.minY + s;
			}
			for (let n of e) {
				let r = this.areaNodes.get(n), i = a.get(n), o = t.get(n);
				if (!(!r || !i || !o)) {
					for (let r of e) {
						if (n === r) continue;
						let e = t.get(r);
						if (!e) continue;
						let a = (o.minX + o.maxX) / 2, s = (o.minY + o.maxY) / 2, c = (e.minX + e.maxX) / 2, l = (e.minY + e.maxY) / 2, u = a - c, d = s - l, f = (o.maxX - o.minX) / 2, p = (o.maxY - o.minY) / 2, m = (e.maxX - e.minX) / 2, h = (e.maxY - e.minY) / 2, g = f + m + 50, _ = p + h + 50, v = g - Math.abs(u), y = _ - Math.abs(d);
						if (v > 0 && y > 0) if (v < y) {
							let e = v * (u >= 0 ? 1 : -1) * .5;
							i.vx += e;
						} else {
							let e = y * (d >= 0 ? 1 : -1) * .5;
							i.vy += e;
						}
					}
					for (let t of r.connections) {
						let n = this.areaNodes.get(t.toAreaId);
						if (!n || !e.includes(t.toAreaId)) continue;
						let a = n.x - r.x, o = n.y - r.y, s = Math.sqrt(a * a + o * o) || 1, c = (s - (this.settings.areaWidth + this.settings.areaSpacing + 50)) * .015;
						i.vx += a / s * c, i.vy += o / s * c;
					}
				}
			}
			for (let t of e) {
				let e = this.areaNodes.get(t), n = a.get(t);
				!e || !n || (e.x += n.vx, e.y += n.vy, n.vx *= i, n.vy *= i);
			}
		}
	}
	applyForces(e, t) {
		let n = .8, r = this.settings.areaWidth + this.settings.areaSpacing, i = this.settings.areaWidth / 2 + 60, a = new Set(e), o = [], s = /* @__PURE__ */ new Set();
		for (let t of e) {
			let e = this.areaNodes.get(t);
			if (e) for (let n of e.connections) {
				if (!a.has(n.toAreaId)) continue;
				let e = Math.min(t, n.toAreaId) + "-" + Math.max(t, n.toAreaId);
				s.has(e) || (s.add(e), o.push({
					from: t,
					to: n.toAreaId
				}));
			}
		}
		let c = /* @__PURE__ */ new Map();
		for (let t of e) c.set(t, {
			vx: 0,
			vy: 0
		});
		for (let s = 0; s < t; s++) {
			for (let t of e) {
				let n = this.areaNodes.get(t), s = c.get(t);
				if (!n || !s) continue;
				let l = n.x + n.width / 2, u = n.y + n.height / 2;
				for (let r of e) {
					if (t === r) continue;
					let e = this.areaNodes.get(r);
					if (!e) continue;
					let i = (n.width + e.width) / 2 + 20, a = (n.height + e.height) / 2 + 20, o = n.x + n.width / 2, c = n.y + n.height / 2, l = e.x + e.width / 2, u = e.y + e.height / 2, d = o - l, f = c - u, p = i - Math.abs(d), m = a - Math.abs(f);
					p > 0 && m > 0 && (p < m ? s.vx += (d >= 0 ? 1 : -1) * p * .5 : s.vy += (f >= 0 ? 1 : -1) * m * .5);
				}
				for (let e of o) {
					if (e.from === t || e.to === t) continue;
					let n = this.areaNodes.get(e.from), r = this.areaNodes.get(e.to);
					if (!n || !r) continue;
					let a = n.x + n.width / 2, o = n.y + n.height / 2, c = r.x + r.width / 2, d = r.y + r.height / 2, f = this.closestPointOnSegment(l, u, a, o, c, d), p = l - f.x, m = u - f.y, h = Math.sqrt(p * p + m * m) || 1;
					if (h < i) {
						let e = (i - h) * .6;
						s.vx += p / h * e, s.vy += m / h * e;
					}
				}
				for (let e of n.connections) {
					if (!a.has(e.toAreaId)) continue;
					let t = this.areaNodes.get(e.toAreaId);
					if (!t) continue;
					let i = t.x - n.x, o = t.y - n.y, l = Math.sqrt(i * i + o * o) || 1, u = (l - r) * .03;
					s.vx += i / l * u, s.vy += o / l * u;
					let d = this.getDirectionOffset(e.direction), f = n.x + d.x * r, p = n.y + d.y * r, m = c.get(e.toAreaId);
					m && (m.vx += (f - t.x) * .01, m.vy += (p - t.y) * .01);
				}
			}
			for (let t of e) {
				let e = this.areaNodes.get(t), r = c.get(t);
				!e || !r || (e.x += r.vx, e.y += r.vy, r.vx *= n, r.vy *= n);
			}
		}
	}
	closestPointOnSegment(e, t, n, r, i, a) {
		let o = i - n, s = a - r, c = e - n, l = t - r, u = o * o + s * s;
		if (u === 0) return {
			x: n,
			y: r
		};
		let d = (c * o + l * s) / u;
		return d = Math.max(0, Math.min(1, d)), {
			x: n + d * o,
			y: r + d * s
		};
	}
	edgesIntersect(e, t, n, r, i, a, o, s) {
		let c = (e, t, n, r, i, a) => (a - t) * (n - e) > (r - t) * (i - e);
		return c(e, t, i, a, o, s) !== c(n, r, i, a, o, s) && c(e, t, n, r, i, a) !== c(e, t, n, r, o, s);
	}
	drawConnections() {
		this.connectionLayer.destroyChildren();
		for (let e of this.connectionGroups) {
			let t = this.areaNodes.get(e.fromAreaId), n = this.areaNodes.get(e.toAreaId);
			if (!t || !n || !isFinite(t.x) || !isFinite(t.y) || !isFinite(n.x) || !isFinite(n.y)) continue;
			let r = {
				x: t.x + t.width / 2,
				y: t.y + t.height / 2
			}, i = {
				x: n.x + n.width / 2,
				y: n.y + n.height / 2
			}, a, o;
			if (this.dotsMode ? (a = r, o = i) : (a = this.getEdgePoint(t, i), o = this.getEdgePoint(n, r)), !isFinite(a.x) || !isFinite(a.y) || !isFinite(o.x) || !isFinite(o.y)) continue;
			let s = this.dotsMode ? "#ffffff" : this.settings.connectionColor, c = this.dotsMode ? 1 : Math.min(this.settings.connectionLineWidth, 1 + e.connections.length * .5), l = new D.Line({
				points: [
					a.x,
					a.y,
					o.x,
					o.y
				],
				stroke: s,
				strokeWidth: c,
				lineCap: "round",
				listening: !1
			});
			this.connectionLayer.add(l);
		}
	}
	getEdgePoint(e, t) {
		let n = e.x + e.width / 2, r = e.y + e.height / 2, i = t.x - n, a = t.y - r, o = e.width / 2, s = e.height / 2;
		if (i === 0 && a === 0) return {
			x: n,
			y: r
		};
		let c = Math.abs(i), l = Math.abs(a), u;
		return u = c / o > l / s ? o / c : s / l, {
			x: n + i * u,
			y: r + a * u
		};
	}
	drawAreas() {
		this.areaLayer.destroyChildren();
		for (let [, e] of this.areaNodes) {
			if (!isFinite(e.x) || !isFinite(e.y)) continue;
			let t = e.areaId === this.highlightedArea;
			if (this.dotsMode) {
				let n = e.x + e.width / 2, r = e.y + e.height / 2, i = new D.Group({
					x: n,
					y: r,
					draggable: !0
				}), a = new D.Circle({
					radius: 6,
					fill: t ? this.settings.highlightColor : "#ffffff",
					stroke: t ? this.settings.highlightColor : "#ffffff",
					strokeWidth: 1
				}), o = new D.Text({
					text: e.name,
					fontSize: 10,
					fill: "#ffffff",
					x: 10,
					y: -5
				});
				i.add(a), i.add(o), i.on("click tap", () => {
					this.emitAreaClickEvent(e.areaId);
				}), i.on("mouseenter", () => {
					this.stage.container().style.cursor = "pointer", a.fill(this.settings.highlightColor), a.stroke(this.settings.highlightColor), this.areaLayer.batchDraw();
				}), i.on("mouseleave", () => {
					this.stage.container().style.cursor = "auto", a.fill(t ? this.settings.highlightColor : "#ffffff"), a.stroke(t ? this.settings.highlightColor : "#ffffff"), this.areaLayer.batchDraw();
				}), i.on("dragmove", () => {
					e.x = i.x() - e.width / 2, e.y = i.y() - e.height / 2, this.drawConnections(), this.connectionLayer.batchDraw();
				}), i.on("dragstart", () => {
					this.stage.container().style.cursor = "grabbing";
				}), i.on("dragend", () => {
					this.stage.container().style.cursor = "pointer";
				}), this.areaLayer.add(i);
			} else {
				let n = new D.Group({
					x: e.x,
					y: e.y,
					draggable: !0
				}), r = new D.Rect({
					width: e.width,
					height: e.height,
					fill: this.settings.areaFillColor,
					stroke: t ? this.settings.highlightColor : this.settings.areaStrokeColor,
					strokeWidth: t ? 3 : 2,
					cornerRadius: 8
				}), i = new D.Text({
					text: e.name,
					fontSize: this.settings.fontSize,
					fill: this.settings.textColor,
					width: e.width - 10,
					height: e.height - 20,
					x: 5,
					y: 10,
					align: "center",
					verticalAlign: "middle",
					ellipsis: !0,
					wrap: "word"
				}), a = new D.Text({
					text: `${e.roomCount} rooms`,
					fontSize: 10,
					fill: this.settings.connectionColor,
					width: e.width - 10,
					x: 5,
					y: e.height - 18,
					align: "center"
				});
				n.add(r), n.add(i), n.add(a), n.on("click tap", () => {
					this.emitAreaClickEvent(e.areaId);
				}), n.on("mouseenter", () => {
					this.stage.container().style.cursor = "pointer", r.stroke(this.settings.highlightColor), this.areaLayer.batchDraw();
				}), n.on("mouseleave", () => {
					this.stage.container().style.cursor = "auto", r.stroke(t ? this.settings.highlightColor : this.settings.areaStrokeColor), this.areaLayer.batchDraw();
				}), n.on("dragmove", () => {
					e.x = n.x(), e.y = n.y(), this.drawConnections(), this.connectionLayer.batchDraw();
				}), n.on("dragstart", () => {
					this.stage.container().style.cursor = "grabbing";
				}), n.on("dragend", () => {
					this.stage.container().style.cursor = "pointer";
				}), this.areaLayer.add(n);
			}
		}
	}
	centerView() {
		let e = Infinity, t = Infinity, n = -Infinity, r = -Infinity;
		for (let [, i] of this.areaNodes) e = Math.min(e, i.x), t = Math.min(t, i.y), n = Math.max(n, i.x + i.width), r = Math.max(r, i.y + i.height);
		if (!isFinite(e)) return;
		let i = n - e, a = r - t, o = e + i / 2, s = t + a / 2, c = (this.stage.width() - 100) / i, l = (this.stage.height() - 100) / a, u = Math.min(c, l, 1.5);
		this.setZoom(u);
		let d = this.stage.scaleX();
		this.stage.position({
			x: this.stage.width() / 2 - o * d,
			y: this.stage.height() / 2 - s * d
		});
	}
	highlightArea(e) {
		this.highlightedArea = e, this.drawAreas(), this.stage.batchDraw();
	}
	centerOnArea(e) {
		let t = this.areaNodes.get(e);
		if (!t) return;
		let n = this.stage.scaleX(), r = t.x + t.width / 2, i = t.y + t.height / 2;
		this.stage.position({
			x: this.stage.width() / 2 - r * n,
			y: this.stage.height() / 2 - i * n
		}), this.stage.batchDraw();
	}
	emitAreaClickEvent(e) {
		let t = new CustomEvent("areaclick", { detail: { areaId: e } });
		this.stage.container().dispatchEvent(t);
	}
	getAreaNode(e) {
		return this.areaNodes.get(e);
	}
	getConnectionGroups() {
		return this.connectionGroups;
	}
	destroy() {
		this.stage.destroy();
	}
};
//#endregion
export { u as ALL_VISIBLE, Ui as AmbientLightOverlay, ve as Area, wa as AreaMapRenderer, Xr as Blueprint, T as Camera, Ii as CanvasExporter, ei as Construction, ie as CullingManager, si as DarkModern, qe as DrawCommandLayerNode, xa as ExplorationLens, ni as GradientRooms, ii as GraphPaper, ce as HitTester, e as IDENTITY_TRANSFORM, $r as Isometric, da as MapGraph, ye as MapReader, li as MapRenderer, Me as MapState, Je as MaterializingLayerNode, Zr as Neon, Yr as Parchment, _a as PathFinder, _e as Plane, Pi as PngBlobExporter, Li as PngBytesExporter, Ni as PngExporter, ne as ProjectedMapReader, a as ROOM_UI_BORDER_COLOR, c as ROOM_UI_BORDER_THICKNESS, l as ROOM_UI_HIDDEN, Ge as RecordingGroupNode, j as RecordingLayerNode, qi as RippleEffect, ti as SciFi, Qr as Sketchy, ri as StainedGlass, Mi as SvgExporter, ai as Topographic, ci as TreasureMap, oi as Watercolor, ra as WaypointOverlay, E as applyStyleToShapes, di as buildDrawCommands, Fi as canvasToBytes, s as colorLightness, re as compose, ba as composeLenses, lt as computeLodMode, b as computeNeighborSpill, le as computePathData, Ca as createAreaMapSettings, je as createSettings, _ as darkenColor, d as defaultExitTreatment, m as getRoomBorderColor, ge as getRoomBorderThickness, y as hexToRgba, x as identityStyle, Ye as isGradientFill, va as isHashLookupCapable, v as isRoomHidden, N as isViewportDataSource, na as placeLabels, fe as projectRoom, Ti as renderToCanvas, Ze as shapeToRecording, ct as shouldUseRaster, he as spillPositionMap, xi as svgFromBatches, M as transformFill, Jr as treasureMapDecorations };

//# sourceMappingURL=index.mjs.map